/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ScanRouteImport } from './routes/scan'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as LoginLinkRouteImport } from './routes/login_.link'
import { Route as AppTimeEntriesAllRouteImport } from './routes/_app/time-entries-all'
import { Route as AppReviewerLearningsRouteImport } from './routes/_app/reviewer-learnings'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppDownloadRouteImport } from './routes/_app/download'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppCoderLearningsRouteImport } from './routes/_app/coder-learnings'
import { Route as AppAlertsRouteImport } from './routes/_app/alerts'
import { Route as AppActivityRouteImport } from './routes/_app/activity'
import { Route as AppWorkItemsIndexRouteImport } from './routes/_app/work-items.index'
import { Route as AppWikiIndexRouteImport } from './routes/_app/wiki.index'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users.index'
import { Route as AppTimeEntriesIndexRouteImport } from './routes/_app/time-entries.index'
import { Route as AppSyncIndexRouteImport } from './routes/_app/sync.index'
import { Route as AppSuggestionsIndexRouteImport } from './routes/_app/suggestions.index'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects.index'
import { Route as AppMyIndexRouteImport } from './routes/_app/my.index'
import { Route as AppLogSourcesIndexRouteImport } from './routes/_app/log-sources.index'
import { Route as AppIdeasIndexRouteImport } from './routes/_app/ideas.index'
import { Route as AppCustomersIndexRouteImport } from './routes/_app/customers.index'
import { Route as AppBillingIndexRouteImport } from './routes/_app/billing.index'
import { Route as AppAnalysisIndexRouteImport } from './routes/_app/analysis.index'
import { Route as AppAgentsIndexRouteImport } from './routes/_app/agents.index'
import { Route as AppAccountingIndexRouteImport } from './routes/_app/accounting.index'
import { Route as AppWorkItemsIdRouteImport } from './routes/_app/work-items.$id'
import { Route as AppWorkItemIdRouteImport } from './routes/_app/work-item.$id'
import { Route as AppWikiSplatRouteImport } from './routes/_app/wiki.$'
import { Route as AppUsersIdRouteImport } from './routes/_app/users.$id'
import { Route as AppTimeEntriesNewRouteImport } from './routes/_app/time-entries.new'
import { Route as AppSyncIdRouteImport } from './routes/_app/sync.$id'
import { Route as AppSuggestionsWorkItemsRouteImport } from './routes/_app/suggestions.work-items'
import { Route as AppSuggestionsTimeEntriesAllRouteImport } from './routes/_app/suggestions.time-entries-all'
import { Route as AppSuggestionsTimeEntriesRouteImport } from './routes/_app/suggestions.time-entries'
import { Route as AppSuggestionsLearningsRouteImport } from './routes/_app/suggestions.learnings'
import { Route as AppProjectsNewRouteImport } from './routes/_app/projects.new'
import { Route as AppProjectsSlugRouteImport } from './routes/_app/projects.$slug'
import { Route as AppLogSourcesLearningsRouteImport } from './routes/_app/log-sources.learnings'
import { Route as AppIdeasIdRouteImport } from './routes/_app/ideas.$id'
import { Route as AppDownloadScannerRouteImport } from './routes/_app/download_.scanner'
import { Route as AppCustomersNewRouteImport } from './routes/_app/customers.new'
import { Route as AppConnectHubRouteImport } from './routes/_app/connect.hub'
import { Route as AppBillingNewRouteImport } from './routes/_app/billing.new'
import { Route as AppBillingAiSpendRouteImport } from './routes/_app/billing.ai-spend'
import { Route as AppBillingIdRouteImport } from './routes/_app/billing.$id'
import { Route as AppAnalysisWhatsappRouteImport } from './routes/_app/analysis.whatsapp'
import { Route as AppAnalysisSourcesRouteImport } from './routes/_app/analysis.sources'
import { Route as AppAnalysisMeetingsRouteImport } from './routes/_app/analysis.meetings'
import { Route as AppAnalysisEmailRouteImport } from './routes/_app/analysis.email'
import { Route as AppAgentsSlugRouteImport } from './routes/_app/agents.$slug'
import { Route as AppAdminVaultCollectionsRouteImport } from './routes/_app/admin.vault-collections'
import { Route as AppAdminSeafileFoldersRouteImport } from './routes/_app/admin.seafile-folders'
import { Route as AppAccountingVatRouteImport } from './routes/_app/accounting.vat'
import { Route as AppAccountingTaxDocumentsRouteImport } from './routes/_app/accounting.tax-documents'
import { Route as AppAccountingStatementsRouteImport } from './routes/_app/accounting.statements'
import { Route as AppAccountingSettingsRouteImport } from './routes/_app/accounting.settings'
import { Route as AppAccountingRecurringRouteImport } from './routes/_app/accounting.recurring'
import { Route as AppAccountingOpeningRouteImport } from './routes/_app/accounting.opening'
import { Route as AppAccountingMissingRouteImport } from './routes/_app/accounting.missing'
import { Route as AppAccountingLedgerRouteImport } from './routes/_app/accounting.ledger'
import { Route as AppAccountingJournalRouteImport } from './routes/_app/accounting.journal'
import { Route as AppAccountingInboxRouteImport } from './routes/_app/accounting.inbox'
import { Route as AppAccountingDocumentsRouteImport } from './routes/_app/accounting.documents'
import { Route as AppAccountingDataboxRouteImport } from './routes/_app/accounting.databox'
import { Route as AppAccountingCutoverRouteImport } from './routes/_app/accounting.cutover'
import { Route as AppAccountingCashRouteImport } from './routes/_app/accounting.cash'
import { Route as AppAccountingBankRouteImport } from './routes/_app/accounting.bank'
import { Route as AppAccountingAssetsRouteImport } from './routes/_app/accounting.assets'
import { Route as AppGroupProjectRouteImport } from './routes/_app/$group.$project'
import { Route as AppWorkItemsNewIndexRouteImport } from './routes/_app/work-items.new.index'
import { Route as AppProjectsSlugIndexRouteImport } from './routes/_app/projects.$slug.index'
import { Route as AppCustomersIdIndexRouteImport } from './routes/_app/customers.$id.index'
import { Route as AppAnalysisHistoryIndexRouteImport } from './routes/_app/analysis.history.index'
import { Route as AppAnalysisDiscordIndexRouteImport } from './routes/_app/analysis.discord.index'
import { Route as AppAgentsSlugIndexRouteImport } from './routes/_app/agents.$slug.index'
import { Route as AppAccountingInvoicesIndexRouteImport } from './routes/_app/accounting.invoices.index'
import { Route as AppAccountingExpensesIndexRouteImport } from './routes/_app/accounting.expenses.index'
import { Route as AppAccountingContactsIndexRouteImport } from './routes/_app/accounting.contacts.index'
import { Route as AppGroupProjectIndexRouteImport } from './routes/_app/$group.$project.index'
import { Route as AppWorkItemsNewTypeRouteImport } from './routes/_app/work-items.new.$type'
import { Route as AppSuggestionsWorkItemsReviewRouteImport } from './routes/_app/suggestions.work-items_.review'
import { Route as AppProjectsSlugTimeEntriesRouteImport } from './routes/_app/projects.$slug.time-entries'
import { Route as AppProjectsSlugSuggestionsRouteImport } from './routes/_app/projects.$slug.suggestions'
import { Route as AppProjectsSlugSettingsRouteImport } from './routes/_app/projects.$slug.settings'
import { Route as AppProjectsSlugReviewsRouteImport } from './routes/_app/projects.$slug.reviews'
import { Route as AppProjectsSlugPlannerRouteImport } from './routes/_app/projects.$slug.planner'
import { Route as AppProjectsSlugMembersRouteImport } from './routes/_app/projects.$slug.members'
import { Route as AppProjectsSlugKeysRouteImport } from './routes/_app/projects.$slug.keys'
import { Route as AppProjectsSlugFilesRouteImport } from './routes/_app/projects.$slug.files'
import { Route as AppCustomersIdEditRouteImport } from './routes/_app/customers.$id.edit'
import { Route as AppAnalysisHistoryIdRouteImport } from './routes/_app/analysis.history.$id'
import { Route as AppAnalysisDiscordChannelIdRouteImport } from './routes/_app/analysis.discord.$channelId'
import { Route as AppAnalysisChatsChatIdRouteImport } from './routes/_app/analysis.chats.$chatId'
import { Route as AppAgentsSlugVerificationsRouteImport } from './routes/_app/agents.$slug.verifications'
import { Route as AppAgentsSlugManualRouteImport } from './routes/_app/agents.$slug.manual'
import { Route as AppAgentsSlugChangesRouteImport } from './routes/_app/agents.$slug.changes'
import { Route as AppAgentsSlugActivityRouteImport } from './routes/_app/agents.$slug.activity'
import { Route as AppAgentsSlugTabRouteImport } from './routes/_app/agents.$slug.$tab'
import { Route as AppAccountingInvoicesIdRouteImport } from './routes/_app/accounting.invoices.$id'
import { Route as AppAccountingExpensesIdRouteImport } from './routes/_app/accounting.expenses.$id'
import { Route as AppAccountingContactsIdRouteImport } from './routes/_app/accounting.contacts.$id'
import { Route as AppProjectsSlugWorkItemsIndexRouteImport } from './routes/_app/projects.$slug.work-items.index'
import { Route as AppProjectsSlugWikiIndexRouteImport } from './routes/_app/projects.$slug.wiki.index'
import { Route as AppProjectsSlugReleasesIndexRouteImport } from './routes/_app/projects.$slug.releases.index'
import { Route as AppProjectsSlugWikiNewRouteImport } from './routes/_app/projects.$slug.wiki.new'
import { Route as AppProjectsSlugReleasesNewRouteImport } from './routes/_app/projects.$slug.releases.new'
import { Route as AppProjectsSlugWorkItemsNewIndexRouteImport } from './routes/_app/projects.$slug.work-items.new.index'
import { Route as AppProjectsSlugWikiWikiSlugIndexRouteImport } from './routes/_app/projects.$slug.wiki.$wikiSlug.index'
import { Route as AppProjectsSlugReleasesReleaseIdIndexRouteImport } from './routes/_app/projects.$slug.releases.$releaseId.index'
import { Route as AppGroupProjectWork_itemsIndexRouteImport } from './routes/_app/$group.$project.-.work_items.index'
import { Route as AppProjectsSlugWorkItemsNewTypeRouteImport } from './routes/_app/projects.$slug.work-items.new.$type'
import { Route as AppProjectsSlugWikiWikiSlugEditRouteImport } from './routes/_app/projects.$slug.wiki.$wikiSlug.edit'
import { Route as AppProjectsSlugReleasesReleaseIdEditRouteImport } from './routes/_app/projects.$slug.releases.$releaseId.edit'
import { Route as AppGroupProjectWork_itemsIidRouteImport } from './routes/_app/$group.$project_.-.work_items.$iid'

const ScanRoute = ScanRouteImport.update({
  id: '/scan',
  path: '/scan',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const LoginLinkRoute = LoginLinkRouteImport.update({
  id: '/login_/link',
  path: '/login/link',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTimeEntriesAllRoute = AppTimeEntriesAllRouteImport.update({
  id: '/time-entries-all',
  path: '/time-entries-all',
  getParentRoute: () => AppRoute,
} as any)
const AppReviewerLearningsRoute = AppReviewerLearningsRouteImport.update({
  id: '/reviewer-learnings',
  path: '/reviewer-learnings',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppDownloadRoute = AppDownloadRouteImport.update({
  id: '/download',
  path: '/download',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppCoderLearningsRoute = AppCoderLearningsRouteImport.update({
  id: '/coder-learnings',
  path: '/coder-learnings',
  getParentRoute: () => AppRoute,
} as any)
const AppAlertsRoute = AppAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AppRoute,
} as any)
const AppActivityRoute = AppActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkItemsIndexRoute = AppWorkItemsIndexRouteImport.update({
  id: '/work-items/',
  path: '/work-items/',
  getParentRoute: () => AppRoute,
} as any)
const AppWikiIndexRoute = AppWikiIndexRouteImport.update({
  id: '/wiki/',
  path: '/wiki/',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRoute,
} as any)
const AppTimeEntriesIndexRoute = AppTimeEntriesIndexRouteImport.update({
  id: '/time-entries/',
  path: '/time-entries/',
  getParentRoute: () => AppRoute,
} as any)
const AppSyncIndexRoute = AppSyncIndexRouteImport.update({
  id: '/sync/',
  path: '/sync/',
  getParentRoute: () => AppRoute,
} as any)
const AppSuggestionsIndexRoute = AppSuggestionsIndexRouteImport.update({
  id: '/suggestions/',
  path: '/suggestions/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppMyIndexRoute = AppMyIndexRouteImport.update({
  id: '/my/',
  path: '/my/',
  getParentRoute: () => AppRoute,
} as any)
const AppLogSourcesIndexRoute = AppLogSourcesIndexRouteImport.update({
  id: '/log-sources/',
  path: '/log-sources/',
  getParentRoute: () => AppRoute,
} as any)
const AppIdeasIndexRoute = AppIdeasIndexRouteImport.update({
  id: '/ideas/',
  path: '/ideas/',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingIndexRoute = AppBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalysisIndexRoute = AppAnalysisIndexRouteImport.update({
  id: '/analysis/',
  path: '/analysis/',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsIndexRoute = AppAgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingIndexRoute = AppAccountingIndexRouteImport.update({
  id: '/accounting/',
  path: '/accounting/',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkItemsIdRoute = AppWorkItemsIdRouteImport.update({
  id: '/work-items/$id',
  path: '/work-items/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkItemIdRoute = AppWorkItemIdRouteImport.update({
  id: '/work-item/$id',
  path: '/work-item/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppWikiSplatRoute = AppWikiSplatRouteImport.update({
  id: '/wiki/$',
  path: '/wiki/$',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIdRoute = AppUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppTimeEntriesNewRoute = AppTimeEntriesNewRouteImport.update({
  id: '/time-entries/new',
  path: '/time-entries/new',
  getParentRoute: () => AppRoute,
} as any)
const AppSyncIdRoute = AppSyncIdRouteImport.update({
  id: '/sync/$id',
  path: '/sync/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSuggestionsWorkItemsRoute = AppSuggestionsWorkItemsRouteImport.update({
  id: '/suggestions/work-items',
  path: '/suggestions/work-items',
  getParentRoute: () => AppRoute,
} as any)
const AppSuggestionsTimeEntriesAllRoute =
  AppSuggestionsTimeEntriesAllRouteImport.update({
    id: '/suggestions/time-entries-all',
    path: '/suggestions/time-entries-all',
    getParentRoute: () => AppRoute,
  } as any)
const AppSuggestionsTimeEntriesRoute =
  AppSuggestionsTimeEntriesRouteImport.update({
    id: '/suggestions/time-entries',
    path: '/suggestions/time-entries',
    getParentRoute: () => AppRoute,
  } as any)
const AppSuggestionsLearningsRoute = AppSuggestionsLearningsRouteImport.update({
  id: '/suggestions/learnings',
  path: '/suggestions/learnings',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsNewRoute = AppProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsSlugRoute = AppProjectsSlugRouteImport.update({
  id: '/projects/$slug',
  path: '/projects/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppLogSourcesLearningsRoute = AppLogSourcesLearningsRouteImport.update({
  id: '/log-sources/learnings',
  path: '/log-sources/learnings',
  getParentRoute: () => AppRoute,
} as any)
const AppIdeasIdRoute = AppIdeasIdRouteImport.update({
  id: '/ideas/$id',
  path: '/ideas/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDownloadScannerRoute = AppDownloadScannerRouteImport.update({
  id: '/download_/scanner',
  path: '/download/scanner',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersNewRoute = AppCustomersNewRouteImport.update({
  id: '/customers/new',
  path: '/customers/new',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectHubRoute = AppConnectHubRouteImport.update({
  id: '/connect/hub',
  path: '/connect/hub',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingNewRoute = AppBillingNewRouteImport.update({
  id: '/billing/new',
  path: '/billing/new',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingAiSpendRoute = AppBillingAiSpendRouteImport.update({
  id: '/billing/ai-spend',
  path: '/billing/ai-spend',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingIdRoute = AppBillingIdRouteImport.update({
  id: '/billing/$id',
  path: '/billing/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalysisWhatsappRoute = AppAnalysisWhatsappRouteImport.update({
  id: '/analysis/whatsapp',
  path: '/analysis/whatsapp',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalysisSourcesRoute = AppAnalysisSourcesRouteImport.update({
  id: '/analysis/sources',
  path: '/analysis/sources',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalysisMeetingsRoute = AppAnalysisMeetingsRouteImport.update({
  id: '/analysis/meetings',
  path: '/analysis/meetings',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalysisEmailRoute = AppAnalysisEmailRouteImport.update({
  id: '/analysis/email',
  path: '/analysis/email',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsSlugRoute = AppAgentsSlugRouteImport.update({
  id: '/agents/$slug',
  path: '/agents/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminVaultCollectionsRoute =
  AppAdminVaultCollectionsRouteImport.update({
    id: '/admin/vault-collections',
    path: '/admin/vault-collections',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminSeafileFoldersRoute = AppAdminSeafileFoldersRouteImport.update({
  id: '/admin/seafile-folders',
  path: '/admin/seafile-folders',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingVatRoute = AppAccountingVatRouteImport.update({
  id: '/accounting/vat',
  path: '/accounting/vat',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingTaxDocumentsRoute =
  AppAccountingTaxDocumentsRouteImport.update({
    id: '/accounting/tax-documents',
    path: '/accounting/tax-documents',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountingStatementsRoute = AppAccountingStatementsRouteImport.update({
  id: '/accounting/statements',
  path: '/accounting/statements',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingSettingsRoute = AppAccountingSettingsRouteImport.update({
  id: '/accounting/settings',
  path: '/accounting/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingRecurringRoute = AppAccountingRecurringRouteImport.update({
  id: '/accounting/recurring',
  path: '/accounting/recurring',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingOpeningRoute = AppAccountingOpeningRouteImport.update({
  id: '/accounting/opening',
  path: '/accounting/opening',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingMissingRoute = AppAccountingMissingRouteImport.update({
  id: '/accounting/missing',
  path: '/accounting/missing',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingLedgerRoute = AppAccountingLedgerRouteImport.update({
  id: '/accounting/ledger',
  path: '/accounting/ledger',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingJournalRoute = AppAccountingJournalRouteImport.update({
  id: '/accounting/journal',
  path: '/accounting/journal',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingInboxRoute = AppAccountingInboxRouteImport.update({
  id: '/accounting/inbox',
  path: '/accounting/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingDocumentsRoute = AppAccountingDocumentsRouteImport.update({
  id: '/accounting/documents',
  path: '/accounting/documents',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingDataboxRoute = AppAccountingDataboxRouteImport.update({
  id: '/accounting/databox',
  path: '/accounting/databox',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingCutoverRoute = AppAccountingCutoverRouteImport.update({
  id: '/accounting/cutover',
  path: '/accounting/cutover',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingCashRoute = AppAccountingCashRouteImport.update({
  id: '/accounting/cash',
  path: '/accounting/cash',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingBankRoute = AppAccountingBankRouteImport.update({
  id: '/accounting/bank',
  path: '/accounting/bank',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingAssetsRoute = AppAccountingAssetsRouteImport.update({
  id: '/accounting/assets',
  path: '/accounting/assets',
  getParentRoute: () => AppRoute,
} as any)
const AppGroupProjectRoute = AppGroupProjectRouteImport.update({
  id: '/$group/$project',
  path: '/$group/$project',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkItemsNewIndexRoute = AppWorkItemsNewIndexRouteImport.update({
  id: '/work-items/new/',
  path: '/work-items/new/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsSlugIndexRoute = AppProjectsSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppProjectsSlugRoute,
} as any)
const AppCustomersIdIndexRoute = AppCustomersIdIndexRouteImport.update({
  id: '/customers/$id/',
  path: '/customers/$id/',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalysisHistoryIndexRoute = AppAnalysisHistoryIndexRouteImport.update({
  id: '/analysis/history/',
  path: '/analysis/history/',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalysisDiscordIndexRoute = AppAnalysisDiscordIndexRouteImport.update({
  id: '/analysis/discord/',
  path: '/analysis/discord/',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsSlugIndexRoute = AppAgentsSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAgentsSlugRoute,
} as any)
const AppAccountingInvoicesIndexRoute =
  AppAccountingInvoicesIndexRouteImport.update({
    id: '/accounting/invoices/',
    path: '/accounting/invoices/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountingExpensesIndexRoute =
  AppAccountingExpensesIndexRouteImport.update({
    id: '/accounting/expenses/',
    path: '/accounting/expenses/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountingContactsIndexRoute =
  AppAccountingContactsIndexRouteImport.update({
    id: '/accounting/contacts/',
    path: '/accounting/contacts/',
    getParentRoute: () => AppRoute,
  } as any)
const AppGroupProjectIndexRoute = AppGroupProjectIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppGroupProjectRoute,
} as any)
const AppWorkItemsNewTypeRoute = AppWorkItemsNewTypeRouteImport.update({
  id: '/work-items/new/$type',
  path: '/work-items/new/$type',
  getParentRoute: () => AppRoute,
} as any)
const AppSuggestionsWorkItemsReviewRoute =
  AppSuggestionsWorkItemsReviewRouteImport.update({
    id: '/suggestions/work-items_/review',
    path: '/suggestions/work-items/review',
    getParentRoute: () => AppRoute,
  } as any)
const AppProjectsSlugTimeEntriesRoute =
  AppProjectsSlugTimeEntriesRouteImport.update({
    id: '/time-entries',
    path: '/time-entries',
    getParentRoute: () => AppProjectsSlugRoute,
  } as any)
const AppProjectsSlugSuggestionsRoute =
  AppProjectsSlugSuggestionsRouteImport.update({
    id: '/suggestions',
    path: '/suggestions',
    getParentRoute: () => AppProjectsSlugRoute,
  } as any)
const AppProjectsSlugSettingsRoute = AppProjectsSlugSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppProjectsSlugRoute,
} as any)
const AppProjectsSlugReviewsRoute = AppProjectsSlugReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => AppProjectsSlugRoute,
} as any)
const AppProjectsSlugPlannerRoute = AppProjectsSlugPlannerRouteImport.update({
  id: '/planner',
  path: '/planner',
  getParentRoute: () => AppProjectsSlugRoute,
} as any)
const AppProjectsSlugMembersRoute = AppProjectsSlugMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppProjectsSlugRoute,
} as any)
const AppProjectsSlugKeysRoute = AppProjectsSlugKeysRouteImport.update({
  id: '/keys',
  path: '/keys',
  getParentRoute: () => AppProjectsSlugRoute,
} as any)
const AppProjectsSlugFilesRoute = AppProjectsSlugFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AppProjectsSlugRoute,
} as any)
const AppCustomersIdEditRoute = AppCustomersIdEditRouteImport.update({
  id: '/customers/$id/edit',
  path: '/customers/$id/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalysisHistoryIdRoute = AppAnalysisHistoryIdRouteImport.update({
  id: '/analysis/history/$id',
  path: '/analysis/history/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalysisDiscordChannelIdRoute =
  AppAnalysisDiscordChannelIdRouteImport.update({
    id: '/analysis/discord/$channelId',
    path: '/analysis/discord/$channelId',
    getParentRoute: () => AppRoute,
  } as any)
const AppAnalysisChatsChatIdRoute = AppAnalysisChatsChatIdRouteImport.update({
  id: '/analysis/chats/$chatId',
  path: '/analysis/chats/$chatId',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsSlugVerificationsRoute =
  AppAgentsSlugVerificationsRouteImport.update({
    id: '/verifications',
    path: '/verifications',
    getParentRoute: () => AppAgentsSlugRoute,
  } as any)
const AppAgentsSlugManualRoute = AppAgentsSlugManualRouteImport.update({
  id: '/manual',
  path: '/manual',
  getParentRoute: () => AppAgentsSlugRoute,
} as any)
const AppAgentsSlugChangesRoute = AppAgentsSlugChangesRouteImport.update({
  id: '/changes',
  path: '/changes',
  getParentRoute: () => AppAgentsSlugRoute,
} as any)
const AppAgentsSlugActivityRoute = AppAgentsSlugActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppAgentsSlugRoute,
} as any)
const AppAgentsSlugTabRoute = AppAgentsSlugTabRouteImport.update({
  id: '/$tab',
  path: '/$tab',
  getParentRoute: () => AppAgentsSlugRoute,
} as any)
const AppAccountingInvoicesIdRoute = AppAccountingInvoicesIdRouteImport.update({
  id: '/accounting/invoices/$id',
  path: '/accounting/invoices/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingExpensesIdRoute = AppAccountingExpensesIdRouteImport.update({
  id: '/accounting/expenses/$id',
  path: '/accounting/expenses/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingContactsIdRoute = AppAccountingContactsIdRouteImport.update({
  id: '/accounting/contacts/$id',
  path: '/accounting/contacts/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsSlugWorkItemsIndexRoute =
  AppProjectsSlugWorkItemsIndexRouteImport.update({
    id: '/work-items/',
    path: '/work-items/',
    getParentRoute: () => AppProjectsSlugRoute,
  } as any)
const AppProjectsSlugWikiIndexRoute =
  AppProjectsSlugWikiIndexRouteImport.update({
    id: '/wiki/',
    path: '/wiki/',
    getParentRoute: () => AppProjectsSlugRoute,
  } as any)
const AppProjectsSlugReleasesIndexRoute =
  AppProjectsSlugReleasesIndexRouteImport.update({
    id: '/releases/',
    path: '/releases/',
    getParentRoute: () => AppProjectsSlugRoute,
  } as any)
const AppProjectsSlugWikiNewRoute = AppProjectsSlugWikiNewRouteImport.update({
  id: '/wiki/new',
  path: '/wiki/new',
  getParentRoute: () => AppProjectsSlugRoute,
} as any)
const AppProjectsSlugReleasesNewRoute =
  AppProjectsSlugReleasesNewRouteImport.update({
    id: '/releases/new',
    path: '/releases/new',
    getParentRoute: () => AppProjectsSlugRoute,
  } as any)
const AppProjectsSlugWorkItemsNewIndexRoute =
  AppProjectsSlugWorkItemsNewIndexRouteImport.update({
    id: '/work-items/new/',
    path: '/work-items/new/',
    getParentRoute: () => AppProjectsSlugRoute,
  } as any)
const AppProjectsSlugWikiWikiSlugIndexRoute =
  AppProjectsSlugWikiWikiSlugIndexRouteImport.update({
    id: '/wiki/$wikiSlug/',
    path: '/wiki/$wikiSlug/',
    getParentRoute: () => AppProjectsSlugRoute,
  } as any)
const AppProjectsSlugReleasesReleaseIdIndexRoute =
  AppProjectsSlugReleasesReleaseIdIndexRouteImport.update({
    id: '/releases/$releaseId/',
    path: '/releases/$releaseId/',
    getParentRoute: () => AppProjectsSlugRoute,
  } as any)
const AppGroupProjectWork_itemsIndexRoute =
  AppGroupProjectWork_itemsIndexRouteImport.update({
    id: '/-/work_items/',
    path: '/-/work_items/',
    getParentRoute: () => AppGroupProjectRoute,
  } as any)
const AppProjectsSlugWorkItemsNewTypeRoute =
  AppProjectsSlugWorkItemsNewTypeRouteImport.update({
    id: '/work-items/new/$type',
    path: '/work-items/new/$type',
    getParentRoute: () => AppProjectsSlugRoute,
  } as any)
const AppProjectsSlugWikiWikiSlugEditRoute =
  AppProjectsSlugWikiWikiSlugEditRouteImport.update({
    id: '/wiki/$wikiSlug/edit',
    path: '/wiki/$wikiSlug/edit',
    getParentRoute: () => AppProjectsSlugRoute,
  } as any)
const AppProjectsSlugReleasesReleaseIdEditRoute =
  AppProjectsSlugReleasesReleaseIdEditRouteImport.update({
    id: '/releases/$releaseId/edit',
    path: '/releases/$releaseId/edit',
    getParentRoute: () => AppProjectsSlugRoute,
  } as any)
const AppGroupProjectWork_itemsIidRoute =
  AppGroupProjectWork_itemsIidRouteImport.update({
    id: '/$group/$project_/-/work_items/$iid',
    path: '/$group/$project/-/work_items/$iid',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/scan': typeof ScanRoute
  '/activity': typeof AppActivityRoute
  '/alerts': typeof AppAlertsRoute
  '/coder-learnings': typeof AppCoderLearningsRoute
  '/dashboard': typeof AppDashboardRoute
  '/download': typeof AppDownloadRoute
  '/profile': typeof AppProfileRoute
  '/reports': typeof AppReportsRoute
  '/reviewer-learnings': typeof AppReviewerLearningsRoute
  '/time-entries-all': typeof AppTimeEntriesAllRoute
  '/login/link': typeof LoginLinkRoute
  '/$group/$project': typeof AppGroupProjectRouteWithChildren
  '/accounting/assets': typeof AppAccountingAssetsRoute
  '/accounting/bank': typeof AppAccountingBankRoute
  '/accounting/cash': typeof AppAccountingCashRoute
  '/accounting/cutover': typeof AppAccountingCutoverRoute
  '/accounting/databox': typeof AppAccountingDataboxRoute
  '/accounting/documents': typeof AppAccountingDocumentsRoute
  '/accounting/inbox': typeof AppAccountingInboxRoute
  '/accounting/journal': typeof AppAccountingJournalRoute
  '/accounting/ledger': typeof AppAccountingLedgerRoute
  '/accounting/missing': typeof AppAccountingMissingRoute
  '/accounting/opening': typeof AppAccountingOpeningRoute
  '/accounting/recurring': typeof AppAccountingRecurringRoute
  '/accounting/settings': typeof AppAccountingSettingsRoute
  '/accounting/statements': typeof AppAccountingStatementsRoute
  '/accounting/tax-documents': typeof AppAccountingTaxDocumentsRoute
  '/accounting/vat': typeof AppAccountingVatRoute
  '/admin/seafile-folders': typeof AppAdminSeafileFoldersRoute
  '/admin/vault-collections': typeof AppAdminVaultCollectionsRoute
  '/agents/$slug': typeof AppAgentsSlugRouteWithChildren
  '/analysis/email': typeof AppAnalysisEmailRoute
  '/analysis/meetings': typeof AppAnalysisMeetingsRoute
  '/analysis/sources': typeof AppAnalysisSourcesRoute
  '/analysis/whatsapp': typeof AppAnalysisWhatsappRoute
  '/billing/$id': typeof AppBillingIdRoute
  '/billing/ai-spend': typeof AppBillingAiSpendRoute
  '/billing/new': typeof AppBillingNewRoute
  '/connect/hub': typeof AppConnectHubRoute
  '/customers/new': typeof AppCustomersNewRoute
  '/download/scanner': typeof AppDownloadScannerRoute
  '/ideas/$id': typeof AppIdeasIdRoute
  '/log-sources/learnings': typeof AppLogSourcesLearningsRoute
  '/projects/$slug': typeof AppProjectsSlugRouteWithChildren
  '/projects/new': typeof AppProjectsNewRoute
  '/suggestions/learnings': typeof AppSuggestionsLearningsRoute
  '/suggestions/time-entries': typeof AppSuggestionsTimeEntriesRoute
  '/suggestions/time-entries-all': typeof AppSuggestionsTimeEntriesAllRoute
  '/suggestions/work-items': typeof AppSuggestionsWorkItemsRoute
  '/sync/$id': typeof AppSyncIdRoute
  '/time-entries/new': typeof AppTimeEntriesNewRoute
  '/users/$id': typeof AppUsersIdRoute
  '/wiki/$': typeof AppWikiSplatRoute
  '/work-item/$id': typeof AppWorkItemIdRoute
  '/work-items/$id': typeof AppWorkItemsIdRoute
  '/accounting/': typeof AppAccountingIndexRoute
  '/agents/': typeof AppAgentsIndexRoute
  '/analysis/': typeof AppAnalysisIndexRoute
  '/billing/': typeof AppBillingIndexRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/ideas/': typeof AppIdeasIndexRoute
  '/log-sources/': typeof AppLogSourcesIndexRoute
  '/my/': typeof AppMyIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/suggestions/': typeof AppSuggestionsIndexRoute
  '/sync/': typeof AppSyncIndexRoute
  '/time-entries/': typeof AppTimeEntriesIndexRoute
  '/users/': typeof AppUsersIndexRoute
  '/wiki/': typeof AppWikiIndexRoute
  '/work-items/': typeof AppWorkItemsIndexRoute
  '/accounting/contacts/$id': typeof AppAccountingContactsIdRoute
  '/accounting/expenses/$id': typeof AppAccountingExpensesIdRoute
  '/accounting/invoices/$id': typeof AppAccountingInvoicesIdRoute
  '/agents/$slug/$tab': typeof AppAgentsSlugTabRoute
  '/agents/$slug/activity': typeof AppAgentsSlugActivityRoute
  '/agents/$slug/changes': typeof AppAgentsSlugChangesRoute
  '/agents/$slug/manual': typeof AppAgentsSlugManualRoute
  '/agents/$slug/verifications': typeof AppAgentsSlugVerificationsRoute
  '/analysis/chats/$chatId': typeof AppAnalysisChatsChatIdRoute
  '/analysis/discord/$channelId': typeof AppAnalysisDiscordChannelIdRoute
  '/analysis/history/$id': typeof AppAnalysisHistoryIdRoute
  '/customers/$id/edit': typeof AppCustomersIdEditRoute
  '/projects/$slug/files': typeof AppProjectsSlugFilesRoute
  '/projects/$slug/keys': typeof AppProjectsSlugKeysRoute
  '/projects/$slug/members': typeof AppProjectsSlugMembersRoute
  '/projects/$slug/planner': typeof AppProjectsSlugPlannerRoute
  '/projects/$slug/reviews': typeof AppProjectsSlugReviewsRoute
  '/projects/$slug/settings': typeof AppProjectsSlugSettingsRoute
  '/projects/$slug/suggestions': typeof AppProjectsSlugSuggestionsRoute
  '/projects/$slug/time-entries': typeof AppProjectsSlugTimeEntriesRoute
  '/suggestions/work-items/review': typeof AppSuggestionsWorkItemsReviewRoute
  '/work-items/new/$type': typeof AppWorkItemsNewTypeRoute
  '/$group/$project/': typeof AppGroupProjectIndexRoute
  '/accounting/contacts/': typeof AppAccountingContactsIndexRoute
  '/accounting/expenses/': typeof AppAccountingExpensesIndexRoute
  '/accounting/invoices/': typeof AppAccountingInvoicesIndexRoute
  '/agents/$slug/': typeof AppAgentsSlugIndexRoute
  '/analysis/discord/': typeof AppAnalysisDiscordIndexRoute
  '/analysis/history/': typeof AppAnalysisHistoryIndexRoute
  '/customers/$id/': typeof AppCustomersIdIndexRoute
  '/projects/$slug/': typeof AppProjectsSlugIndexRoute
  '/work-items/new/': typeof AppWorkItemsNewIndexRoute
  '/projects/$slug/releases/new': typeof AppProjectsSlugReleasesNewRoute
  '/projects/$slug/wiki/new': typeof AppProjectsSlugWikiNewRoute
  '/projects/$slug/releases/': typeof AppProjectsSlugReleasesIndexRoute
  '/projects/$slug/wiki/': typeof AppProjectsSlugWikiIndexRoute
  '/projects/$slug/work-items/': typeof AppProjectsSlugWorkItemsIndexRoute
  '/$group/$project/-/work_items/$iid': typeof AppGroupProjectWork_itemsIidRoute
  '/projects/$slug/releases/$releaseId/edit': typeof AppProjectsSlugReleasesReleaseIdEditRoute
  '/projects/$slug/wiki/$wikiSlug/edit': typeof AppProjectsSlugWikiWikiSlugEditRoute
  '/projects/$slug/work-items/new/$type': typeof AppProjectsSlugWorkItemsNewTypeRoute
  '/$group/$project/-/work_items/': typeof AppGroupProjectWork_itemsIndexRoute
  '/projects/$slug/releases/$releaseId/': typeof AppProjectsSlugReleasesReleaseIdIndexRoute
  '/projects/$slug/wiki/$wikiSlug/': typeof AppProjectsSlugWikiWikiSlugIndexRoute
  '/projects/$slug/work-items/new/': typeof AppProjectsSlugWorkItemsNewIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/scan': typeof ScanRoute
  '/activity': typeof AppActivityRoute
  '/alerts': typeof AppAlertsRoute
  '/coder-learnings': typeof AppCoderLearningsRoute
  '/dashboard': typeof AppDashboardRoute
  '/download': typeof AppDownloadRoute
  '/profile': typeof AppProfileRoute
  '/reports': typeof AppReportsRoute
  '/reviewer-learnings': typeof AppReviewerLearningsRoute
  '/time-entries-all': typeof AppTimeEntriesAllRoute
  '/login/link': typeof LoginLinkRoute
  '/': typeof AppIndexRoute
  '/accounting/assets': typeof AppAccountingAssetsRoute
  '/accounting/bank': typeof AppAccountingBankRoute
  '/accounting/cash': typeof AppAccountingCashRoute
  '/accounting/cutover': typeof AppAccountingCutoverRoute
  '/accounting/databox': typeof AppAccountingDataboxRoute
  '/accounting/documents': typeof AppAccountingDocumentsRoute
  '/accounting/inbox': typeof AppAccountingInboxRoute
  '/accounting/journal': typeof AppAccountingJournalRoute
  '/accounting/ledger': typeof AppAccountingLedgerRoute
  '/accounting/missing': typeof AppAccountingMissingRoute
  '/accounting/opening': typeof AppAccountingOpeningRoute
  '/accounting/recurring': typeof AppAccountingRecurringRoute
  '/accounting/settings': typeof AppAccountingSettingsRoute
  '/accounting/statements': typeof AppAccountingStatementsRoute
  '/accounting/tax-documents': typeof AppAccountingTaxDocumentsRoute
  '/accounting/vat': typeof AppAccountingVatRoute
  '/admin/seafile-folders': typeof AppAdminSeafileFoldersRoute
  '/admin/vault-collections': typeof AppAdminVaultCollectionsRoute
  '/analysis/email': typeof AppAnalysisEmailRoute
  '/analysis/meetings': typeof AppAnalysisMeetingsRoute
  '/analysis/sources': typeof AppAnalysisSourcesRoute
  '/analysis/whatsapp': typeof AppAnalysisWhatsappRoute
  '/billing/$id': typeof AppBillingIdRoute
  '/billing/ai-spend': typeof AppBillingAiSpendRoute
  '/billing/new': typeof AppBillingNewRoute
  '/connect/hub': typeof AppConnectHubRoute
  '/customers/new': typeof AppCustomersNewRoute
  '/download/scanner': typeof AppDownloadScannerRoute
  '/ideas/$id': typeof AppIdeasIdRoute
  '/log-sources/learnings': typeof AppLogSourcesLearningsRoute
  '/projects/new': typeof AppProjectsNewRoute
  '/suggestions/learnings': typeof AppSuggestionsLearningsRoute
  '/suggestions/time-entries': typeof AppSuggestionsTimeEntriesRoute
  '/suggestions/time-entries-all': typeof AppSuggestionsTimeEntriesAllRoute
  '/suggestions/work-items': typeof AppSuggestionsWorkItemsRoute
  '/sync/$id': typeof AppSyncIdRoute
  '/time-entries/new': typeof AppTimeEntriesNewRoute
  '/users/$id': typeof AppUsersIdRoute
  '/wiki/$': typeof AppWikiSplatRoute
  '/work-item/$id': typeof AppWorkItemIdRoute
  '/work-items/$id': typeof AppWorkItemsIdRoute
  '/accounting': typeof AppAccountingIndexRoute
  '/agents': typeof AppAgentsIndexRoute
  '/analysis': typeof AppAnalysisIndexRoute
  '/billing': typeof AppBillingIndexRoute
  '/customers': typeof AppCustomersIndexRoute
  '/ideas': typeof AppIdeasIndexRoute
  '/log-sources': typeof AppLogSourcesIndexRoute
  '/my': typeof AppMyIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/suggestions': typeof AppSuggestionsIndexRoute
  '/sync': typeof AppSyncIndexRoute
  '/time-entries': typeof AppTimeEntriesIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/wiki': typeof AppWikiIndexRoute
  '/work-items': typeof AppWorkItemsIndexRoute
  '/accounting/contacts/$id': typeof AppAccountingContactsIdRoute
  '/accounting/expenses/$id': typeof AppAccountingExpensesIdRoute
  '/accounting/invoices/$id': typeof AppAccountingInvoicesIdRoute
  '/agents/$slug/$tab': typeof AppAgentsSlugTabRoute
  '/agents/$slug/activity': typeof AppAgentsSlugActivityRoute
  '/agents/$slug/changes': typeof AppAgentsSlugChangesRoute
  '/agents/$slug/manual': typeof AppAgentsSlugManualRoute
  '/agents/$slug/verifications': typeof AppAgentsSlugVerificationsRoute
  '/analysis/chats/$chatId': typeof AppAnalysisChatsChatIdRoute
  '/analysis/discord/$channelId': typeof AppAnalysisDiscordChannelIdRoute
  '/analysis/history/$id': typeof AppAnalysisHistoryIdRoute
  '/customers/$id/edit': typeof AppCustomersIdEditRoute
  '/projects/$slug/files': typeof AppProjectsSlugFilesRoute
  '/projects/$slug/keys': typeof AppProjectsSlugKeysRoute
  '/projects/$slug/members': typeof AppProjectsSlugMembersRoute
  '/projects/$slug/planner': typeof AppProjectsSlugPlannerRoute
  '/projects/$slug/reviews': typeof AppProjectsSlugReviewsRoute
  '/projects/$slug/settings': typeof AppProjectsSlugSettingsRoute
  '/projects/$slug/suggestions': typeof AppProjectsSlugSuggestionsRoute
  '/projects/$slug/time-entries': typeof AppProjectsSlugTimeEntriesRoute
  '/suggestions/work-items/review': typeof AppSuggestionsWorkItemsReviewRoute
  '/work-items/new/$type': typeof AppWorkItemsNewTypeRoute
  '/$group/$project': typeof AppGroupProjectIndexRoute
  '/accounting/contacts': typeof AppAccountingContactsIndexRoute
  '/accounting/expenses': typeof AppAccountingExpensesIndexRoute
  '/accounting/invoices': typeof AppAccountingInvoicesIndexRoute
  '/agents/$slug': typeof AppAgentsSlugIndexRoute
  '/analysis/discord': typeof AppAnalysisDiscordIndexRoute
  '/analysis/history': typeof AppAnalysisHistoryIndexRoute
  '/customers/$id': typeof AppCustomersIdIndexRoute
  '/projects/$slug': typeof AppProjectsSlugIndexRoute
  '/work-items/new': typeof AppWorkItemsNewIndexRoute
  '/projects/$slug/releases/new': typeof AppProjectsSlugReleasesNewRoute
  '/projects/$slug/wiki/new': typeof AppProjectsSlugWikiNewRoute
  '/projects/$slug/releases': typeof AppProjectsSlugReleasesIndexRoute
  '/projects/$slug/wiki': typeof AppProjectsSlugWikiIndexRoute
  '/projects/$slug/work-items': typeof AppProjectsSlugWorkItemsIndexRoute
  '/$group/$project/-/work_items/$iid': typeof AppGroupProjectWork_itemsIidRoute
  '/projects/$slug/releases/$releaseId/edit': typeof AppProjectsSlugReleasesReleaseIdEditRoute
  '/projects/$slug/wiki/$wikiSlug/edit': typeof AppProjectsSlugWikiWikiSlugEditRoute
  '/projects/$slug/work-items/new/$type': typeof AppProjectsSlugWorkItemsNewTypeRoute
  '/$group/$project/-/work_items': typeof AppGroupProjectWork_itemsIndexRoute
  '/projects/$slug/releases/$releaseId': typeof AppProjectsSlugReleasesReleaseIdIndexRoute
  '/projects/$slug/wiki/$wikiSlug': typeof AppProjectsSlugWikiWikiSlugIndexRoute
  '/projects/$slug/work-items/new': typeof AppProjectsSlugWorkItemsNewIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/scan': typeof ScanRoute
  '/_app/activity': typeof AppActivityRoute
  '/_app/alerts': typeof AppAlertsRoute
  '/_app/coder-learnings': typeof AppCoderLearningsRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/download': typeof AppDownloadRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/reviewer-learnings': typeof AppReviewerLearningsRoute
  '/_app/time-entries-all': typeof AppTimeEntriesAllRoute
  '/login_/link': typeof LoginLinkRoute
  '/_app/': typeof AppIndexRoute
  '/_app/$group/$project': typeof AppGroupProjectRouteWithChildren
  '/_app/accounting/assets': typeof AppAccountingAssetsRoute
  '/_app/accounting/bank': typeof AppAccountingBankRoute
  '/_app/accounting/cash': typeof AppAccountingCashRoute
  '/_app/accounting/cutover': typeof AppAccountingCutoverRoute
  '/_app/accounting/databox': typeof AppAccountingDataboxRoute
  '/_app/accounting/documents': typeof AppAccountingDocumentsRoute
  '/_app/accounting/inbox': typeof AppAccountingInboxRoute
  '/_app/accounting/journal': typeof AppAccountingJournalRoute
  '/_app/accounting/ledger': typeof AppAccountingLedgerRoute
  '/_app/accounting/missing': typeof AppAccountingMissingRoute
  '/_app/accounting/opening': typeof AppAccountingOpeningRoute
  '/_app/accounting/recurring': typeof AppAccountingRecurringRoute
  '/_app/accounting/settings': typeof AppAccountingSettingsRoute
  '/_app/accounting/statements': typeof AppAccountingStatementsRoute
  '/_app/accounting/tax-documents': typeof AppAccountingTaxDocumentsRoute
  '/_app/accounting/vat': typeof AppAccountingVatRoute
  '/_app/admin/seafile-folders': typeof AppAdminSeafileFoldersRoute
  '/_app/admin/vault-collections': typeof AppAdminVaultCollectionsRoute
  '/_app/agents/$slug': typeof AppAgentsSlugRouteWithChildren
  '/_app/analysis/email': typeof AppAnalysisEmailRoute
  '/_app/analysis/meetings': typeof AppAnalysisMeetingsRoute
  '/_app/analysis/sources': typeof AppAnalysisSourcesRoute
  '/_app/analysis/whatsapp': typeof AppAnalysisWhatsappRoute
  '/_app/billing/$id': typeof AppBillingIdRoute
  '/_app/billing/ai-spend': typeof AppBillingAiSpendRoute
  '/_app/billing/new': typeof AppBillingNewRoute
  '/_app/connect/hub': typeof AppConnectHubRoute
  '/_app/customers/new': typeof AppCustomersNewRoute
  '/_app/download_/scanner': typeof AppDownloadScannerRoute
  '/_app/ideas/$id': typeof AppIdeasIdRoute
  '/_app/log-sources/learnings': typeof AppLogSourcesLearningsRoute
  '/_app/projects/$slug': typeof AppProjectsSlugRouteWithChildren
  '/_app/projects/new': typeof AppProjectsNewRoute
  '/_app/suggestions/learnings': typeof AppSuggestionsLearningsRoute
  '/_app/suggestions/time-entries': typeof AppSuggestionsTimeEntriesRoute
  '/_app/suggestions/time-entries-all': typeof AppSuggestionsTimeEntriesAllRoute
  '/_app/suggestions/work-items': typeof AppSuggestionsWorkItemsRoute
  '/_app/sync/$id': typeof AppSyncIdRoute
  '/_app/time-entries/new': typeof AppTimeEntriesNewRoute
  '/_app/users/$id': typeof AppUsersIdRoute
  '/_app/wiki/$': typeof AppWikiSplatRoute
  '/_app/work-item/$id': typeof AppWorkItemIdRoute
  '/_app/work-items/$id': typeof AppWorkItemsIdRoute
  '/_app/accounting/': typeof AppAccountingIndexRoute
  '/_app/agents/': typeof AppAgentsIndexRoute
  '/_app/analysis/': typeof AppAnalysisIndexRoute
  '/_app/billing/': typeof AppBillingIndexRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/ideas/': typeof AppIdeasIndexRoute
  '/_app/log-sources/': typeof AppLogSourcesIndexRoute
  '/_app/my/': typeof AppMyIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/suggestions/': typeof AppSuggestionsIndexRoute
  '/_app/sync/': typeof AppSyncIndexRoute
  '/_app/time-entries/': typeof AppTimeEntriesIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/wiki/': typeof AppWikiIndexRoute
  '/_app/work-items/': typeof AppWorkItemsIndexRoute
  '/_app/accounting/contacts/$id': typeof AppAccountingContactsIdRoute
  '/_app/accounting/expenses/$id': typeof AppAccountingExpensesIdRoute
  '/_app/accounting/invoices/$id': typeof AppAccountingInvoicesIdRoute
  '/_app/agents/$slug/$tab': typeof AppAgentsSlugTabRoute
  '/_app/agents/$slug/activity': typeof AppAgentsSlugActivityRoute
  '/_app/agents/$slug/changes': typeof AppAgentsSlugChangesRoute
  '/_app/agents/$slug/manual': typeof AppAgentsSlugManualRoute
  '/_app/agents/$slug/verifications': typeof AppAgentsSlugVerificationsRoute
  '/_app/analysis/chats/$chatId': typeof AppAnalysisChatsChatIdRoute
  '/_app/analysis/discord/$channelId': typeof AppAnalysisDiscordChannelIdRoute
  '/_app/analysis/history/$id': typeof AppAnalysisHistoryIdRoute
  '/_app/customers/$id/edit': typeof AppCustomersIdEditRoute
  '/_app/projects/$slug/files': typeof AppProjectsSlugFilesRoute
  '/_app/projects/$slug/keys': typeof AppProjectsSlugKeysRoute
  '/_app/projects/$slug/members': typeof AppProjectsSlugMembersRoute
  '/_app/projects/$slug/planner': typeof AppProjectsSlugPlannerRoute
  '/_app/projects/$slug/reviews': typeof AppProjectsSlugReviewsRoute
  '/_app/projects/$slug/settings': typeof AppProjectsSlugSettingsRoute
  '/_app/projects/$slug/suggestions': typeof AppProjectsSlugSuggestionsRoute
  '/_app/projects/$slug/time-entries': typeof AppProjectsSlugTimeEntriesRoute
  '/_app/suggestions/work-items_/review': typeof AppSuggestionsWorkItemsReviewRoute
  '/_app/work-items/new/$type': typeof AppWorkItemsNewTypeRoute
  '/_app/$group/$project/': typeof AppGroupProjectIndexRoute
  '/_app/accounting/contacts/': typeof AppAccountingContactsIndexRoute
  '/_app/accounting/expenses/': typeof AppAccountingExpensesIndexRoute
  '/_app/accounting/invoices/': typeof AppAccountingInvoicesIndexRoute
  '/_app/agents/$slug/': typeof AppAgentsSlugIndexRoute
  '/_app/analysis/discord/': typeof AppAnalysisDiscordIndexRoute
  '/_app/analysis/history/': typeof AppAnalysisHistoryIndexRoute
  '/_app/customers/$id/': typeof AppCustomersIdIndexRoute
  '/_app/projects/$slug/': typeof AppProjectsSlugIndexRoute
  '/_app/work-items/new/': typeof AppWorkItemsNewIndexRoute
  '/_app/projects/$slug/releases/new': typeof AppProjectsSlugReleasesNewRoute
  '/_app/projects/$slug/wiki/new': typeof AppProjectsSlugWikiNewRoute
  '/_app/projects/$slug/releases/': typeof AppProjectsSlugReleasesIndexRoute
  '/_app/projects/$slug/wiki/': typeof AppProjectsSlugWikiIndexRoute
  '/_app/projects/$slug/work-items/': typeof AppProjectsSlugWorkItemsIndexRoute
  '/_app/$group/$project_/-/work_items/$iid': typeof AppGroupProjectWork_itemsIidRoute
  '/_app/projects/$slug/releases/$releaseId/edit': typeof AppProjectsSlugReleasesReleaseIdEditRoute
  '/_app/projects/$slug/wiki/$wikiSlug/edit': typeof AppProjectsSlugWikiWikiSlugEditRoute
  '/_app/projects/$slug/work-items/new/$type': typeof AppProjectsSlugWorkItemsNewTypeRoute
  '/_app/$group/$project/-/work_items/': typeof AppGroupProjectWork_itemsIndexRoute
  '/_app/projects/$slug/releases/$releaseId/': typeof AppProjectsSlugReleasesReleaseIdIndexRoute
  '/_app/projects/$slug/wiki/$wikiSlug/': typeof AppProjectsSlugWikiWikiSlugIndexRoute
  '/_app/projects/$slug/work-items/new/': typeof AppProjectsSlugWorkItemsNewIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/scan'
    | '/activity'
    | '/alerts'
    | '/coder-learnings'
    | '/dashboard'
    | '/download'
    | '/profile'
    | '/reports'
    | '/reviewer-learnings'
    | '/time-entries-all'
    | '/login/link'
    | '/$group/$project'
    | '/accounting/assets'
    | '/accounting/bank'
    | '/accounting/cash'
    | '/accounting/cutover'
    | '/accounting/databox'
    | '/accounting/documents'
    | '/accounting/inbox'
    | '/accounting/journal'
    | '/accounting/ledger'
    | '/accounting/missing'
    | '/accounting/opening'
    | '/accounting/recurring'
    | '/accounting/settings'
    | '/accounting/statements'
    | '/accounting/tax-documents'
    | '/accounting/vat'
    | '/admin/seafile-folders'
    | '/admin/vault-collections'
    | '/agents/$slug'
    | '/analysis/email'
    | '/analysis/meetings'
    | '/analysis/sources'
    | '/analysis/whatsapp'
    | '/billing/$id'
    | '/billing/ai-spend'
    | '/billing/new'
    | '/connect/hub'
    | '/customers/new'
    | '/download/scanner'
    | '/ideas/$id'
    | '/log-sources/learnings'
    | '/projects/$slug'
    | '/projects/new'
    | '/suggestions/learnings'
    | '/suggestions/time-entries'
    | '/suggestions/time-entries-all'
    | '/suggestions/work-items'
    | '/sync/$id'
    | '/time-entries/new'
    | '/users/$id'
    | '/wiki/$'
    | '/work-item/$id'
    | '/work-items/$id'
    | '/accounting/'
    | '/agents/'
    | '/analysis/'
    | '/billing/'
    | '/customers/'
    | '/ideas/'
    | '/log-sources/'
    | '/my/'
    | '/projects/'
    | '/suggestions/'
    | '/sync/'
    | '/time-entries/'
    | '/users/'
    | '/wiki/'
    | '/work-items/'
    | '/accounting/contacts/$id'
    | '/accounting/expenses/$id'
    | '/accounting/invoices/$id'
    | '/agents/$slug/$tab'
    | '/agents/$slug/activity'
    | '/agents/$slug/changes'
    | '/agents/$slug/manual'
    | '/agents/$slug/verifications'
    | '/analysis/chats/$chatId'
    | '/analysis/discord/$channelId'
    | '/analysis/history/$id'
    | '/customers/$id/edit'
    | '/projects/$slug/files'
    | '/projects/$slug/keys'
    | '/projects/$slug/members'
    | '/projects/$slug/planner'
    | '/projects/$slug/reviews'
    | '/projects/$slug/settings'
    | '/projects/$slug/suggestions'
    | '/projects/$slug/time-entries'
    | '/suggestions/work-items/review'
    | '/work-items/new/$type'
    | '/$group/$project/'
    | '/accounting/contacts/'
    | '/accounting/expenses/'
    | '/accounting/invoices/'
    | '/agents/$slug/'
    | '/analysis/discord/'
    | '/analysis/history/'
    | '/customers/$id/'
    | '/projects/$slug/'
    | '/work-items/new/'
    | '/projects/$slug/releases/new'
    | '/projects/$slug/wiki/new'
    | '/projects/$slug/releases/'
    | '/projects/$slug/wiki/'
    | '/projects/$slug/work-items/'
    | '/$group/$project/-/work_items/$iid'
    | '/projects/$slug/releases/$releaseId/edit'
    | '/projects/$slug/wiki/$wikiSlug/edit'
    | '/projects/$slug/work-items/new/$type'
    | '/$group/$project/-/work_items/'
    | '/projects/$slug/releases/$releaseId/'
    | '/projects/$slug/wiki/$wikiSlug/'
    | '/projects/$slug/work-items/new/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/scan'
    | '/activity'
    | '/alerts'
    | '/coder-learnings'
    | '/dashboard'
    | '/download'
    | '/profile'
    | '/reports'
    | '/reviewer-learnings'
    | '/time-entries-all'
    | '/login/link'
    | '/'
    | '/accounting/assets'
    | '/accounting/bank'
    | '/accounting/cash'
    | '/accounting/cutover'
    | '/accounting/databox'
    | '/accounting/documents'
    | '/accounting/inbox'
    | '/accounting/journal'
    | '/accounting/ledger'
    | '/accounting/missing'
    | '/accounting/opening'
    | '/accounting/recurring'
    | '/accounting/settings'
    | '/accounting/statements'
    | '/accounting/tax-documents'
    | '/accounting/vat'
    | '/admin/seafile-folders'
    | '/admin/vault-collections'
    | '/analysis/email'
    | '/analysis/meetings'
    | '/analysis/sources'
    | '/analysis/whatsapp'
    | '/billing/$id'
    | '/billing/ai-spend'
    | '/billing/new'
    | '/connect/hub'
    | '/customers/new'
    | '/download/scanner'
    | '/ideas/$id'
    | '/log-sources/learnings'
    | '/projects/new'
    | '/suggestions/learnings'
    | '/suggestions/time-entries'
    | '/suggestions/time-entries-all'
    | '/suggestions/work-items'
    | '/sync/$id'
    | '/time-entries/new'
    | '/users/$id'
    | '/wiki/$'
    | '/work-item/$id'
    | '/work-items/$id'
    | '/accounting'
    | '/agents'
    | '/analysis'
    | '/billing'
    | '/customers'
    | '/ideas'
    | '/log-sources'
    | '/my'
    | '/projects'
    | '/suggestions'
    | '/sync'
    | '/time-entries'
    | '/users'
    | '/wiki'
    | '/work-items'
    | '/accounting/contacts/$id'
    | '/accounting/expenses/$id'
    | '/accounting/invoices/$id'
    | '/agents/$slug/$tab'
    | '/agents/$slug/activity'
    | '/agents/$slug/changes'
    | '/agents/$slug/manual'
    | '/agents/$slug/verifications'
    | '/analysis/chats/$chatId'
    | '/analysis/discord/$channelId'
    | '/analysis/history/$id'
    | '/customers/$id/edit'
    | '/projects/$slug/files'
    | '/projects/$slug/keys'
    | '/projects/$slug/members'
    | '/projects/$slug/planner'
    | '/projects/$slug/reviews'
    | '/projects/$slug/settings'
    | '/projects/$slug/suggestions'
    | '/projects/$slug/time-entries'
    | '/suggestions/work-items/review'
    | '/work-items/new/$type'
    | '/$group/$project'
    | '/accounting/contacts'
    | '/accounting/expenses'
    | '/accounting/invoices'
    | '/agents/$slug'
    | '/analysis/discord'
    | '/analysis/history'
    | '/customers/$id'
    | '/projects/$slug'
    | '/work-items/new'
    | '/projects/$slug/releases/new'
    | '/projects/$slug/wiki/new'
    | '/projects/$slug/releases'
    | '/projects/$slug/wiki'
    | '/projects/$slug/work-items'
    | '/$group/$project/-/work_items/$iid'
    | '/projects/$slug/releases/$releaseId/edit'
    | '/projects/$slug/wiki/$wikiSlug/edit'
    | '/projects/$slug/work-items/new/$type'
    | '/$group/$project/-/work_items'
    | '/projects/$slug/releases/$releaseId'
    | '/projects/$slug/wiki/$wikiSlug'
    | '/projects/$slug/work-items/new'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/scan'
    | '/_app/activity'
    | '/_app/alerts'
    | '/_app/coder-learnings'
    | '/_app/dashboard'
    | '/_app/download'
    | '/_app/profile'
    | '/_app/reports'
    | '/_app/reviewer-learnings'
    | '/_app/time-entries-all'
    | '/login_/link'
    | '/_app/'
    | '/_app/$group/$project'
    | '/_app/accounting/assets'
    | '/_app/accounting/bank'
    | '/_app/accounting/cash'
    | '/_app/accounting/cutover'
    | '/_app/accounting/databox'
    | '/_app/accounting/documents'
    | '/_app/accounting/inbox'
    | '/_app/accounting/journal'
    | '/_app/accounting/ledger'
    | '/_app/accounting/missing'
    | '/_app/accounting/opening'
    | '/_app/accounting/recurring'
    | '/_app/accounting/settings'
    | '/_app/accounting/statements'
    | '/_app/accounting/tax-documents'
    | '/_app/accounting/vat'
    | '/_app/admin/seafile-folders'
    | '/_app/admin/vault-collections'
    | '/_app/agents/$slug'
    | '/_app/analysis/email'
    | '/_app/analysis/meetings'
    | '/_app/analysis/sources'
    | '/_app/analysis/whatsapp'
    | '/_app/billing/$id'
    | '/_app/billing/ai-spend'
    | '/_app/billing/new'
    | '/_app/connect/hub'
    | '/_app/customers/new'
    | '/_app/download_/scanner'
    | '/_app/ideas/$id'
    | '/_app/log-sources/learnings'
    | '/_app/projects/$slug'
    | '/_app/projects/new'
    | '/_app/suggestions/learnings'
    | '/_app/suggestions/time-entries'
    | '/_app/suggestions/time-entries-all'
    | '/_app/suggestions/work-items'
    | '/_app/sync/$id'
    | '/_app/time-entries/new'
    | '/_app/users/$id'
    | '/_app/wiki/$'
    | '/_app/work-item/$id'
    | '/_app/work-items/$id'
    | '/_app/accounting/'
    | '/_app/agents/'
    | '/_app/analysis/'
    | '/_app/billing/'
    | '/_app/customers/'
    | '/_app/ideas/'
    | '/_app/log-sources/'
    | '/_app/my/'
    | '/_app/projects/'
    | '/_app/suggestions/'
    | '/_app/sync/'
    | '/_app/time-entries/'
    | '/_app/users/'
    | '/_app/wiki/'
    | '/_app/work-items/'
    | '/_app/accounting/contacts/$id'
    | '/_app/accounting/expenses/$id'
    | '/_app/accounting/invoices/$id'
    | '/_app/agents/$slug/$tab'
    | '/_app/agents/$slug/activity'
    | '/_app/agents/$slug/changes'
    | '/_app/agents/$slug/manual'
    | '/_app/agents/$slug/verifications'
    | '/_app/analysis/chats/$chatId'
    | '/_app/analysis/discord/$channelId'
    | '/_app/analysis/history/$id'
    | '/_app/customers/$id/edit'
    | '/_app/projects/$slug/files'
    | '/_app/projects/$slug/keys'
    | '/_app/projects/$slug/members'
    | '/_app/projects/$slug/planner'
    | '/_app/projects/$slug/reviews'
    | '/_app/projects/$slug/settings'
    | '/_app/projects/$slug/suggestions'
    | '/_app/projects/$slug/time-entries'
    | '/_app/suggestions/work-items_/review'
    | '/_app/work-items/new/$type'
    | '/_app/$group/$project/'
    | '/_app/accounting/contacts/'
    | '/_app/accounting/expenses/'
    | '/_app/accounting/invoices/'
    | '/_app/agents/$slug/'
    | '/_app/analysis/discord/'
    | '/_app/analysis/history/'
    | '/_app/customers/$id/'
    | '/_app/projects/$slug/'
    | '/_app/work-items/new/'
    | '/_app/projects/$slug/releases/new'
    | '/_app/projects/$slug/wiki/new'
    | '/_app/projects/$slug/releases/'
    | '/_app/projects/$slug/wiki/'
    | '/_app/projects/$slug/work-items/'
    | '/_app/$group/$project_/-/work_items/$iid'
    | '/_app/projects/$slug/releases/$releaseId/edit'
    | '/_app/projects/$slug/wiki/$wikiSlug/edit'
    | '/_app/projects/$slug/work-items/new/$type'
    | '/_app/$group/$project/-/work_items/'
    | '/_app/projects/$slug/releases/$releaseId/'
    | '/_app/projects/$slug/wiki/$wikiSlug/'
    | '/_app/projects/$slug/work-items/new/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  ScanRoute: typeof ScanRoute
  LoginLinkRoute: typeof LoginLinkRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/scan': {
      id: '/scan'
      path: '/scan'
      fullPath: '/scan'
      preLoaderRoute: typeof ScanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/login_/link': {
      id: '/login_/link'
      path: '/login/link'
      fullPath: '/login/link'
      preLoaderRoute: typeof LoginLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/time-entries-all': {
      id: '/_app/time-entries-all'
      path: '/time-entries-all'
      fullPath: '/time-entries-all'
      preLoaderRoute: typeof AppTimeEntriesAllRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reviewer-learnings': {
      id: '/_app/reviewer-learnings'
      path: '/reviewer-learnings'
      fullPath: '/reviewer-learnings'
      preLoaderRoute: typeof AppReviewerLearningsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/download': {
      id: '/_app/download'
      path: '/download'
      fullPath: '/download'
      preLoaderRoute: typeof AppDownloadRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/coder-learnings': {
      id: '/_app/coder-learnings'
      path: '/coder-learnings'
      fullPath: '/coder-learnings'
      preLoaderRoute: typeof AppCoderLearningsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/alerts': {
      id: '/_app/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AppAlertsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/activity': {
      id: '/_app/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AppActivityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/work-items/': {
      id: '/_app/work-items/'
      path: '/work-items'
      fullPath: '/work-items/'
      preLoaderRoute: typeof AppWorkItemsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/wiki/': {
      id: '/_app/wiki/'
      path: '/wiki'
      fullPath: '/wiki/'
      preLoaderRoute: typeof AppWikiIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/time-entries/': {
      id: '/_app/time-entries/'
      path: '/time-entries'
      fullPath: '/time-entries/'
      preLoaderRoute: typeof AppTimeEntriesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sync/': {
      id: '/_app/sync/'
      path: '/sync'
      fullPath: '/sync/'
      preLoaderRoute: typeof AppSyncIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suggestions/': {
      id: '/_app/suggestions/'
      path: '/suggestions'
      fullPath: '/suggestions/'
      preLoaderRoute: typeof AppSuggestionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my/': {
      id: '/_app/my/'
      path: '/my'
      fullPath: '/my/'
      preLoaderRoute: typeof AppMyIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/log-sources/': {
      id: '/_app/log-sources/'
      path: '/log-sources'
      fullPath: '/log-sources/'
      preLoaderRoute: typeof AppLogSourcesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ideas/': {
      id: '/_app/ideas/'
      path: '/ideas'
      fullPath: '/ideas/'
      preLoaderRoute: typeof AppIdeasIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/': {
      id: '/_app/billing/'
      path: '/billing'
      fullPath: '/billing/'
      preLoaderRoute: typeof AppBillingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analysis/': {
      id: '/_app/analysis/'
      path: '/analysis'
      fullPath: '/analysis/'
      preLoaderRoute: typeof AppAnalysisIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/': {
      id: '/_app/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AppAgentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/': {
      id: '/_app/accounting/'
      path: '/accounting'
      fullPath: '/accounting/'
      preLoaderRoute: typeof AppAccountingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/work-items/$id': {
      id: '/_app/work-items/$id'
      path: '/work-items/$id'
      fullPath: '/work-items/$id'
      preLoaderRoute: typeof AppWorkItemsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/work-item/$id': {
      id: '/_app/work-item/$id'
      path: '/work-item/$id'
      fullPath: '/work-item/$id'
      preLoaderRoute: typeof AppWorkItemIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/wiki/$': {
      id: '/_app/wiki/$'
      path: '/wiki/$'
      fullPath: '/wiki/$'
      preLoaderRoute: typeof AppWikiSplatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/$id': {
      id: '/_app/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AppUsersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/time-entries/new': {
      id: '/_app/time-entries/new'
      path: '/time-entries/new'
      fullPath: '/time-entries/new'
      preLoaderRoute: typeof AppTimeEntriesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sync/$id': {
      id: '/_app/sync/$id'
      path: '/sync/$id'
      fullPath: '/sync/$id'
      preLoaderRoute: typeof AppSyncIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suggestions/work-items': {
      id: '/_app/suggestions/work-items'
      path: '/suggestions/work-items'
      fullPath: '/suggestions/work-items'
      preLoaderRoute: typeof AppSuggestionsWorkItemsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suggestions/time-entries-all': {
      id: '/_app/suggestions/time-entries-all'
      path: '/suggestions/time-entries-all'
      fullPath: '/suggestions/time-entries-all'
      preLoaderRoute: typeof AppSuggestionsTimeEntriesAllRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suggestions/time-entries': {
      id: '/_app/suggestions/time-entries'
      path: '/suggestions/time-entries'
      fullPath: '/suggestions/time-entries'
      preLoaderRoute: typeof AppSuggestionsTimeEntriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suggestions/learnings': {
      id: '/_app/suggestions/learnings'
      path: '/suggestions/learnings'
      fullPath: '/suggestions/learnings'
      preLoaderRoute: typeof AppSuggestionsLearningsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/new': {
      id: '/_app/projects/new'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof AppProjectsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$slug': {
      id: '/_app/projects/$slug'
      path: '/projects/$slug'
      fullPath: '/projects/$slug'
      preLoaderRoute: typeof AppProjectsSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/log-sources/learnings': {
      id: '/_app/log-sources/learnings'
      path: '/log-sources/learnings'
      fullPath: '/log-sources/learnings'
      preLoaderRoute: typeof AppLogSourcesLearningsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ideas/$id': {
      id: '/_app/ideas/$id'
      path: '/ideas/$id'
      fullPath: '/ideas/$id'
      preLoaderRoute: typeof AppIdeasIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/download_/scanner': {
      id: '/_app/download_/scanner'
      path: '/download/scanner'
      fullPath: '/download/scanner'
      preLoaderRoute: typeof AppDownloadScannerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/new': {
      id: '/_app/customers/new'
      path: '/customers/new'
      fullPath: '/customers/new'
      preLoaderRoute: typeof AppCustomersNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connect/hub': {
      id: '/_app/connect/hub'
      path: '/connect/hub'
      fullPath: '/connect/hub'
      preLoaderRoute: typeof AppConnectHubRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/new': {
      id: '/_app/billing/new'
      path: '/billing/new'
      fullPath: '/billing/new'
      preLoaderRoute: typeof AppBillingNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/ai-spend': {
      id: '/_app/billing/ai-spend'
      path: '/billing/ai-spend'
      fullPath: '/billing/ai-spend'
      preLoaderRoute: typeof AppBillingAiSpendRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/$id': {
      id: '/_app/billing/$id'
      path: '/billing/$id'
      fullPath: '/billing/$id'
      preLoaderRoute: typeof AppBillingIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analysis/whatsapp': {
      id: '/_app/analysis/whatsapp'
      path: '/analysis/whatsapp'
      fullPath: '/analysis/whatsapp'
      preLoaderRoute: typeof AppAnalysisWhatsappRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analysis/sources': {
      id: '/_app/analysis/sources'
      path: '/analysis/sources'
      fullPath: '/analysis/sources'
      preLoaderRoute: typeof AppAnalysisSourcesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analysis/meetings': {
      id: '/_app/analysis/meetings'
      path: '/analysis/meetings'
      fullPath: '/analysis/meetings'
      preLoaderRoute: typeof AppAnalysisMeetingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analysis/email': {
      id: '/_app/analysis/email'
      path: '/analysis/email'
      fullPath: '/analysis/email'
      preLoaderRoute: typeof AppAnalysisEmailRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/$slug': {
      id: '/_app/agents/$slug'
      path: '/agents/$slug'
      fullPath: '/agents/$slug'
      preLoaderRoute: typeof AppAgentsSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/vault-collections': {
      id: '/_app/admin/vault-collections'
      path: '/admin/vault-collections'
      fullPath: '/admin/vault-collections'
      preLoaderRoute: typeof AppAdminVaultCollectionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/seafile-folders': {
      id: '/_app/admin/seafile-folders'
      path: '/admin/seafile-folders'
      fullPath: '/admin/seafile-folders'
      preLoaderRoute: typeof AppAdminSeafileFoldersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/vat': {
      id: '/_app/accounting/vat'
      path: '/accounting/vat'
      fullPath: '/accounting/vat'
      preLoaderRoute: typeof AppAccountingVatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/tax-documents': {
      id: '/_app/accounting/tax-documents'
      path: '/accounting/tax-documents'
      fullPath: '/accounting/tax-documents'
      preLoaderRoute: typeof AppAccountingTaxDocumentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/statements': {
      id: '/_app/accounting/statements'
      path: '/accounting/statements'
      fullPath: '/accounting/statements'
      preLoaderRoute: typeof AppAccountingStatementsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/settings': {
      id: '/_app/accounting/settings'
      path: '/accounting/settings'
      fullPath: '/accounting/settings'
      preLoaderRoute: typeof AppAccountingSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/recurring': {
      id: '/_app/accounting/recurring'
      path: '/accounting/recurring'
      fullPath: '/accounting/recurring'
      preLoaderRoute: typeof AppAccountingRecurringRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/opening': {
      id: '/_app/accounting/opening'
      path: '/accounting/opening'
      fullPath: '/accounting/opening'
      preLoaderRoute: typeof AppAccountingOpeningRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/missing': {
      id: '/_app/accounting/missing'
      path: '/accounting/missing'
      fullPath: '/accounting/missing'
      preLoaderRoute: typeof AppAccountingMissingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/ledger': {
      id: '/_app/accounting/ledger'
      path: '/accounting/ledger'
      fullPath: '/accounting/ledger'
      preLoaderRoute: typeof AppAccountingLedgerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/journal': {
      id: '/_app/accounting/journal'
      path: '/accounting/journal'
      fullPath: '/accounting/journal'
      preLoaderRoute: typeof AppAccountingJournalRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/inbox': {
      id: '/_app/accounting/inbox'
      path: '/accounting/inbox'
      fullPath: '/accounting/inbox'
      preLoaderRoute: typeof AppAccountingInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/documents': {
      id: '/_app/accounting/documents'
      path: '/accounting/documents'
      fullPath: '/accounting/documents'
      preLoaderRoute: typeof AppAccountingDocumentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/databox': {
      id: '/_app/accounting/databox'
      path: '/accounting/databox'
      fullPath: '/accounting/databox'
      preLoaderRoute: typeof AppAccountingDataboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/cutover': {
      id: '/_app/accounting/cutover'
      path: '/accounting/cutover'
      fullPath: '/accounting/cutover'
      preLoaderRoute: typeof AppAccountingCutoverRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/cash': {
      id: '/_app/accounting/cash'
      path: '/accounting/cash'
      fullPath: '/accounting/cash'
      preLoaderRoute: typeof AppAccountingCashRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/bank': {
      id: '/_app/accounting/bank'
      path: '/accounting/bank'
      fullPath: '/accounting/bank'
      preLoaderRoute: typeof AppAccountingBankRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/assets': {
      id: '/_app/accounting/assets'
      path: '/accounting/assets'
      fullPath: '/accounting/assets'
      preLoaderRoute: typeof AppAccountingAssetsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$group/$project': {
      id: '/_app/$group/$project'
      path: '/$group/$project'
      fullPath: '/$group/$project'
      preLoaderRoute: typeof AppGroupProjectRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/work-items/new/': {
      id: '/_app/work-items/new/'
      path: '/work-items/new'
      fullPath: '/work-items/new/'
      preLoaderRoute: typeof AppWorkItemsNewIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$slug/': {
      id: '/_app/projects/$slug/'
      path: '/'
      fullPath: '/projects/$slug/'
      preLoaderRoute: typeof AppProjectsSlugIndexRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/customers/$id/': {
      id: '/_app/customers/$id/'
      path: '/customers/$id'
      fullPath: '/customers/$id/'
      preLoaderRoute: typeof AppCustomersIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analysis/history/': {
      id: '/_app/analysis/history/'
      path: '/analysis/history'
      fullPath: '/analysis/history/'
      preLoaderRoute: typeof AppAnalysisHistoryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analysis/discord/': {
      id: '/_app/analysis/discord/'
      path: '/analysis/discord'
      fullPath: '/analysis/discord/'
      preLoaderRoute: typeof AppAnalysisDiscordIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/$slug/': {
      id: '/_app/agents/$slug/'
      path: '/'
      fullPath: '/agents/$slug/'
      preLoaderRoute: typeof AppAgentsSlugIndexRouteImport
      parentRoute: typeof AppAgentsSlugRoute
    }
    '/_app/accounting/invoices/': {
      id: '/_app/accounting/invoices/'
      path: '/accounting/invoices'
      fullPath: '/accounting/invoices/'
      preLoaderRoute: typeof AppAccountingInvoicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/expenses/': {
      id: '/_app/accounting/expenses/'
      path: '/accounting/expenses'
      fullPath: '/accounting/expenses/'
      preLoaderRoute: typeof AppAccountingExpensesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/contacts/': {
      id: '/_app/accounting/contacts/'
      path: '/accounting/contacts'
      fullPath: '/accounting/contacts/'
      preLoaderRoute: typeof AppAccountingContactsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$group/$project/': {
      id: '/_app/$group/$project/'
      path: '/'
      fullPath: '/$group/$project/'
      preLoaderRoute: typeof AppGroupProjectIndexRouteImport
      parentRoute: typeof AppGroupProjectRoute
    }
    '/_app/work-items/new/$type': {
      id: '/_app/work-items/new/$type'
      path: '/work-items/new/$type'
      fullPath: '/work-items/new/$type'
      preLoaderRoute: typeof AppWorkItemsNewTypeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suggestions/work-items_/review': {
      id: '/_app/suggestions/work-items_/review'
      path: '/suggestions/work-items/review'
      fullPath: '/suggestions/work-items/review'
      preLoaderRoute: typeof AppSuggestionsWorkItemsReviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$slug/time-entries': {
      id: '/_app/projects/$slug/time-entries'
      path: '/time-entries'
      fullPath: '/projects/$slug/time-entries'
      preLoaderRoute: typeof AppProjectsSlugTimeEntriesRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/projects/$slug/suggestions': {
      id: '/_app/projects/$slug/suggestions'
      path: '/suggestions'
      fullPath: '/projects/$slug/suggestions'
      preLoaderRoute: typeof AppProjectsSlugSuggestionsRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/projects/$slug/settings': {
      id: '/_app/projects/$slug/settings'
      path: '/settings'
      fullPath: '/projects/$slug/settings'
      preLoaderRoute: typeof AppProjectsSlugSettingsRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/projects/$slug/reviews': {
      id: '/_app/projects/$slug/reviews'
      path: '/reviews'
      fullPath: '/projects/$slug/reviews'
      preLoaderRoute: typeof AppProjectsSlugReviewsRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/projects/$slug/planner': {
      id: '/_app/projects/$slug/planner'
      path: '/planner'
      fullPath: '/projects/$slug/planner'
      preLoaderRoute: typeof AppProjectsSlugPlannerRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/projects/$slug/members': {
      id: '/_app/projects/$slug/members'
      path: '/members'
      fullPath: '/projects/$slug/members'
      preLoaderRoute: typeof AppProjectsSlugMembersRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/projects/$slug/keys': {
      id: '/_app/projects/$slug/keys'
      path: '/keys'
      fullPath: '/projects/$slug/keys'
      preLoaderRoute: typeof AppProjectsSlugKeysRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/projects/$slug/files': {
      id: '/_app/projects/$slug/files'
      path: '/files'
      fullPath: '/projects/$slug/files'
      preLoaderRoute: typeof AppProjectsSlugFilesRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/customers/$id/edit': {
      id: '/_app/customers/$id/edit'
      path: '/customers/$id/edit'
      fullPath: '/customers/$id/edit'
      preLoaderRoute: typeof AppCustomersIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analysis/history/$id': {
      id: '/_app/analysis/history/$id'
      path: '/analysis/history/$id'
      fullPath: '/analysis/history/$id'
      preLoaderRoute: typeof AppAnalysisHistoryIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analysis/discord/$channelId': {
      id: '/_app/analysis/discord/$channelId'
      path: '/analysis/discord/$channelId'
      fullPath: '/analysis/discord/$channelId'
      preLoaderRoute: typeof AppAnalysisDiscordChannelIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analysis/chats/$chatId': {
      id: '/_app/analysis/chats/$chatId'
      path: '/analysis/chats/$chatId'
      fullPath: '/analysis/chats/$chatId'
      preLoaderRoute: typeof AppAnalysisChatsChatIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/$slug/verifications': {
      id: '/_app/agents/$slug/verifications'
      path: '/verifications'
      fullPath: '/agents/$slug/verifications'
      preLoaderRoute: typeof AppAgentsSlugVerificationsRouteImport
      parentRoute: typeof AppAgentsSlugRoute
    }
    '/_app/agents/$slug/manual': {
      id: '/_app/agents/$slug/manual'
      path: '/manual'
      fullPath: '/agents/$slug/manual'
      preLoaderRoute: typeof AppAgentsSlugManualRouteImport
      parentRoute: typeof AppAgentsSlugRoute
    }
    '/_app/agents/$slug/changes': {
      id: '/_app/agents/$slug/changes'
      path: '/changes'
      fullPath: '/agents/$slug/changes'
      preLoaderRoute: typeof AppAgentsSlugChangesRouteImport
      parentRoute: typeof AppAgentsSlugRoute
    }
    '/_app/agents/$slug/activity': {
      id: '/_app/agents/$slug/activity'
      path: '/activity'
      fullPath: '/agents/$slug/activity'
      preLoaderRoute: typeof AppAgentsSlugActivityRouteImport
      parentRoute: typeof AppAgentsSlugRoute
    }
    '/_app/agents/$slug/$tab': {
      id: '/_app/agents/$slug/$tab'
      path: '/$tab'
      fullPath: '/agents/$slug/$tab'
      preLoaderRoute: typeof AppAgentsSlugTabRouteImport
      parentRoute: typeof AppAgentsSlugRoute
    }
    '/_app/accounting/invoices/$id': {
      id: '/_app/accounting/invoices/$id'
      path: '/accounting/invoices/$id'
      fullPath: '/accounting/invoices/$id'
      preLoaderRoute: typeof AppAccountingInvoicesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/expenses/$id': {
      id: '/_app/accounting/expenses/$id'
      path: '/accounting/expenses/$id'
      fullPath: '/accounting/expenses/$id'
      preLoaderRoute: typeof AppAccountingExpensesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/contacts/$id': {
      id: '/_app/accounting/contacts/$id'
      path: '/accounting/contacts/$id'
      fullPath: '/accounting/contacts/$id'
      preLoaderRoute: typeof AppAccountingContactsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$slug/work-items/': {
      id: '/_app/projects/$slug/work-items/'
      path: '/work-items'
      fullPath: '/projects/$slug/work-items/'
      preLoaderRoute: typeof AppProjectsSlugWorkItemsIndexRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/projects/$slug/wiki/': {
      id: '/_app/projects/$slug/wiki/'
      path: '/wiki'
      fullPath: '/projects/$slug/wiki/'
      preLoaderRoute: typeof AppProjectsSlugWikiIndexRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/projects/$slug/releases/': {
      id: '/_app/projects/$slug/releases/'
      path: '/releases'
      fullPath: '/projects/$slug/releases/'
      preLoaderRoute: typeof AppProjectsSlugReleasesIndexRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/projects/$slug/wiki/new': {
      id: '/_app/projects/$slug/wiki/new'
      path: '/wiki/new'
      fullPath: '/projects/$slug/wiki/new'
      preLoaderRoute: typeof AppProjectsSlugWikiNewRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/projects/$slug/releases/new': {
      id: '/_app/projects/$slug/releases/new'
      path: '/releases/new'
      fullPath: '/projects/$slug/releases/new'
      preLoaderRoute: typeof AppProjectsSlugReleasesNewRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/projects/$slug/work-items/new/': {
      id: '/_app/projects/$slug/work-items/new/'
      path: '/work-items/new'
      fullPath: '/projects/$slug/work-items/new/'
      preLoaderRoute: typeof AppProjectsSlugWorkItemsNewIndexRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/projects/$slug/wiki/$wikiSlug/': {
      id: '/_app/projects/$slug/wiki/$wikiSlug/'
      path: '/wiki/$wikiSlug'
      fullPath: '/projects/$slug/wiki/$wikiSlug/'
      preLoaderRoute: typeof AppProjectsSlugWikiWikiSlugIndexRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/projects/$slug/releases/$releaseId/': {
      id: '/_app/projects/$slug/releases/$releaseId/'
      path: '/releases/$releaseId'
      fullPath: '/projects/$slug/releases/$releaseId/'
      preLoaderRoute: typeof AppProjectsSlugReleasesReleaseIdIndexRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/$group/$project/-/work_items/': {
      id: '/_app/$group/$project/-/work_items/'
      path: '/-/work_items'
      fullPath: '/$group/$project/-/work_items/'
      preLoaderRoute: typeof AppGroupProjectWork_itemsIndexRouteImport
      parentRoute: typeof AppGroupProjectRoute
    }
    '/_app/projects/$slug/work-items/new/$type': {
      id: '/_app/projects/$slug/work-items/new/$type'
      path: '/work-items/new/$type'
      fullPath: '/projects/$slug/work-items/new/$type'
      preLoaderRoute: typeof AppProjectsSlugWorkItemsNewTypeRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/projects/$slug/wiki/$wikiSlug/edit': {
      id: '/_app/projects/$slug/wiki/$wikiSlug/edit'
      path: '/wiki/$wikiSlug/edit'
      fullPath: '/projects/$slug/wiki/$wikiSlug/edit'
      preLoaderRoute: typeof AppProjectsSlugWikiWikiSlugEditRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/projects/$slug/releases/$releaseId/edit': {
      id: '/_app/projects/$slug/releases/$releaseId/edit'
      path: '/releases/$releaseId/edit'
      fullPath: '/projects/$slug/releases/$releaseId/edit'
      preLoaderRoute: typeof AppProjectsSlugReleasesReleaseIdEditRouteImport
      parentRoute: typeof AppProjectsSlugRoute
    }
    '/_app/$group/$project_/-/work_items/$iid': {
      id: '/_app/$group/$project_/-/work_items/$iid'
      path: '/$group/$project/-/work_items/$iid'
      fullPath: '/$group/$project/-/work_items/$iid'
      preLoaderRoute: typeof AppGroupProjectWork_itemsIidRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppGroupProjectRouteChildren {
  AppGroupProjectIndexRoute: typeof AppGroupProjectIndexRoute
  AppGroupProjectWork_itemsIndexRoute: typeof AppGroupProjectWork_itemsIndexRoute
}

const AppGroupProjectRouteChildren: AppGroupProjectRouteChildren = {
  AppGroupProjectIndexRoute: AppGroupProjectIndexRoute,
  AppGroupProjectWork_itemsIndexRoute: AppGroupProjectWork_itemsIndexRoute,
}

const AppGroupProjectRouteWithChildren = AppGroupProjectRoute._addFileChildren(
  AppGroupProjectRouteChildren,
)

interface AppAgentsSlugRouteChildren {
  AppAgentsSlugTabRoute: typeof AppAgentsSlugTabRoute
  AppAgentsSlugActivityRoute: typeof AppAgentsSlugActivityRoute
  AppAgentsSlugChangesRoute: typeof AppAgentsSlugChangesRoute
  AppAgentsSlugManualRoute: typeof AppAgentsSlugManualRoute
  AppAgentsSlugVerificationsRoute: typeof AppAgentsSlugVerificationsRoute
  AppAgentsSlugIndexRoute: typeof AppAgentsSlugIndexRoute
}

const AppAgentsSlugRouteChildren: AppAgentsSlugRouteChildren = {
  AppAgentsSlugTabRoute: AppAgentsSlugTabRoute,
  AppAgentsSlugActivityRoute: AppAgentsSlugActivityRoute,
  AppAgentsSlugChangesRoute: AppAgentsSlugChangesRoute,
  AppAgentsSlugManualRoute: AppAgentsSlugManualRoute,
  AppAgentsSlugVerificationsRoute: AppAgentsSlugVerificationsRoute,
  AppAgentsSlugIndexRoute: AppAgentsSlugIndexRoute,
}

const AppAgentsSlugRouteWithChildren = AppAgentsSlugRoute._addFileChildren(
  AppAgentsSlugRouteChildren,
)

interface AppProjectsSlugRouteChildren {
  AppProjectsSlugFilesRoute: typeof AppProjectsSlugFilesRoute
  AppProjectsSlugKeysRoute: typeof AppProjectsSlugKeysRoute
  AppProjectsSlugMembersRoute: typeof AppProjectsSlugMembersRoute
  AppProjectsSlugPlannerRoute: typeof AppProjectsSlugPlannerRoute
  AppProjectsSlugReviewsRoute: typeof AppProjectsSlugReviewsRoute
  AppProjectsSlugSettingsRoute: typeof AppProjectsSlugSettingsRoute
  AppProjectsSlugSuggestionsRoute: typeof AppProjectsSlugSuggestionsRoute
  AppProjectsSlugTimeEntriesRoute: typeof AppProjectsSlugTimeEntriesRoute
  AppProjectsSlugIndexRoute: typeof AppProjectsSlugIndexRoute
  AppProjectsSlugReleasesNewRoute: typeof AppProjectsSlugReleasesNewRoute
  AppProjectsSlugWikiNewRoute: typeof AppProjectsSlugWikiNewRoute
  AppProjectsSlugReleasesIndexRoute: typeof AppProjectsSlugReleasesIndexRoute
  AppProjectsSlugWikiIndexRoute: typeof AppProjectsSlugWikiIndexRoute
  AppProjectsSlugWorkItemsIndexRoute: typeof AppProjectsSlugWorkItemsIndexRoute
  AppProjectsSlugReleasesReleaseIdEditRoute: typeof AppProjectsSlugReleasesReleaseIdEditRoute
  AppProjectsSlugWikiWikiSlugEditRoute: typeof AppProjectsSlugWikiWikiSlugEditRoute
  AppProjectsSlugWorkItemsNewTypeRoute: typeof AppProjectsSlugWorkItemsNewTypeRoute
  AppProjectsSlugReleasesReleaseIdIndexRoute: typeof AppProjectsSlugReleasesReleaseIdIndexRoute
  AppProjectsSlugWikiWikiSlugIndexRoute: typeof AppProjectsSlugWikiWikiSlugIndexRoute
  AppProjectsSlugWorkItemsNewIndexRoute: typeof AppProjectsSlugWorkItemsNewIndexRoute
}

const AppProjectsSlugRouteChildren: AppProjectsSlugRouteChildren = {
  AppProjectsSlugFilesRoute: AppProjectsSlugFilesRoute,
  AppProjectsSlugKeysRoute: AppProjectsSlugKeysRoute,
  AppProjectsSlugMembersRoute: AppProjectsSlugMembersRoute,
  AppProjectsSlugPlannerRoute: AppProjectsSlugPlannerRoute,
  AppProjectsSlugReviewsRoute: AppProjectsSlugReviewsRoute,
  AppProjectsSlugSettingsRoute: AppProjectsSlugSettingsRoute,
  AppProjectsSlugSuggestionsRoute: AppProjectsSlugSuggestionsRoute,
  AppProjectsSlugTimeEntriesRoute: AppProjectsSlugTimeEntriesRoute,
  AppProjectsSlugIndexRoute: AppProjectsSlugIndexRoute,
  AppProjectsSlugReleasesNewRoute: AppProjectsSlugReleasesNewRoute,
  AppProjectsSlugWikiNewRoute: AppProjectsSlugWikiNewRoute,
  AppProjectsSlugReleasesIndexRoute: AppProjectsSlugReleasesIndexRoute,
  AppProjectsSlugWikiIndexRoute: AppProjectsSlugWikiIndexRoute,
  AppProjectsSlugWorkItemsIndexRoute: AppProjectsSlugWorkItemsIndexRoute,
  AppProjectsSlugReleasesReleaseIdEditRoute:
    AppProjectsSlugReleasesReleaseIdEditRoute,
  AppProjectsSlugWikiWikiSlugEditRoute: AppProjectsSlugWikiWikiSlugEditRoute,
  AppProjectsSlugWorkItemsNewTypeRoute: AppProjectsSlugWorkItemsNewTypeRoute,
  AppProjectsSlugReleasesReleaseIdIndexRoute:
    AppProjectsSlugReleasesReleaseIdIndexRoute,
  AppProjectsSlugWikiWikiSlugIndexRoute: AppProjectsSlugWikiWikiSlugIndexRoute,
  AppProjectsSlugWorkItemsNewIndexRoute: AppProjectsSlugWorkItemsNewIndexRoute,
}

const AppProjectsSlugRouteWithChildren = AppProjectsSlugRoute._addFileChildren(
  AppProjectsSlugRouteChildren,
)

interface AppRouteChildren {
  AppActivityRoute: typeof AppActivityRoute
  AppAlertsRoute: typeof AppAlertsRoute
  AppCoderLearningsRoute: typeof AppCoderLearningsRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppDownloadRoute: typeof AppDownloadRoute
  AppProfileRoute: typeof AppProfileRoute
  AppReportsRoute: typeof AppReportsRoute
  AppReviewerLearningsRoute: typeof AppReviewerLearningsRoute
  AppTimeEntriesAllRoute: typeof AppTimeEntriesAllRoute
  AppIndexRoute: typeof AppIndexRoute
  AppGroupProjectRoute: typeof AppGroupProjectRouteWithChildren
  AppAccountingAssetsRoute: typeof AppAccountingAssetsRoute
  AppAccountingBankRoute: typeof AppAccountingBankRoute
  AppAccountingCashRoute: typeof AppAccountingCashRoute
  AppAccountingCutoverRoute: typeof AppAccountingCutoverRoute
  AppAccountingDataboxRoute: typeof AppAccountingDataboxRoute
  AppAccountingDocumentsRoute: typeof AppAccountingDocumentsRoute
  AppAccountingInboxRoute: typeof AppAccountingInboxRoute
  AppAccountingJournalRoute: typeof AppAccountingJournalRoute
  AppAccountingLedgerRoute: typeof AppAccountingLedgerRoute
  AppAccountingMissingRoute: typeof AppAccountingMissingRoute
  AppAccountingOpeningRoute: typeof AppAccountingOpeningRoute
  AppAccountingRecurringRoute: typeof AppAccountingRecurringRoute
  AppAccountingSettingsRoute: typeof AppAccountingSettingsRoute
  AppAccountingStatementsRoute: typeof AppAccountingStatementsRoute
  AppAccountingTaxDocumentsRoute: typeof AppAccountingTaxDocumentsRoute
  AppAccountingVatRoute: typeof AppAccountingVatRoute
  AppAdminSeafileFoldersRoute: typeof AppAdminSeafileFoldersRoute
  AppAdminVaultCollectionsRoute: typeof AppAdminVaultCollectionsRoute
  AppAgentsSlugRoute: typeof AppAgentsSlugRouteWithChildren
  AppAnalysisEmailRoute: typeof AppAnalysisEmailRoute
  AppAnalysisMeetingsRoute: typeof AppAnalysisMeetingsRoute
  AppAnalysisSourcesRoute: typeof AppAnalysisSourcesRoute
  AppAnalysisWhatsappRoute: typeof AppAnalysisWhatsappRoute
  AppBillingIdRoute: typeof AppBillingIdRoute
  AppBillingAiSpendRoute: typeof AppBillingAiSpendRoute
  AppBillingNewRoute: typeof AppBillingNewRoute
  AppConnectHubRoute: typeof AppConnectHubRoute
  AppCustomersNewRoute: typeof AppCustomersNewRoute
  AppDownloadScannerRoute: typeof AppDownloadScannerRoute
  AppIdeasIdRoute: typeof AppIdeasIdRoute
  AppLogSourcesLearningsRoute: typeof AppLogSourcesLearningsRoute
  AppProjectsSlugRoute: typeof AppProjectsSlugRouteWithChildren
  AppProjectsNewRoute: typeof AppProjectsNewRoute
  AppSuggestionsLearningsRoute: typeof AppSuggestionsLearningsRoute
  AppSuggestionsTimeEntriesRoute: typeof AppSuggestionsTimeEntriesRoute
  AppSuggestionsTimeEntriesAllRoute: typeof AppSuggestionsTimeEntriesAllRoute
  AppSuggestionsWorkItemsRoute: typeof AppSuggestionsWorkItemsRoute
  AppSyncIdRoute: typeof AppSyncIdRoute
  AppTimeEntriesNewRoute: typeof AppTimeEntriesNewRoute
  AppUsersIdRoute: typeof AppUsersIdRoute
  AppWikiSplatRoute: typeof AppWikiSplatRoute
  AppWorkItemIdRoute: typeof AppWorkItemIdRoute
  AppWorkItemsIdRoute: typeof AppWorkItemsIdRoute
  AppAccountingIndexRoute: typeof AppAccountingIndexRoute
  AppAgentsIndexRoute: typeof AppAgentsIndexRoute
  AppAnalysisIndexRoute: typeof AppAnalysisIndexRoute
  AppBillingIndexRoute: typeof AppBillingIndexRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
  AppIdeasIndexRoute: typeof AppIdeasIndexRoute
  AppLogSourcesIndexRoute: typeof AppLogSourcesIndexRoute
  AppMyIndexRoute: typeof AppMyIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppSuggestionsIndexRoute: typeof AppSuggestionsIndexRoute
  AppSyncIndexRoute: typeof AppSyncIndexRoute
  AppTimeEntriesIndexRoute: typeof AppTimeEntriesIndexRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
  AppWikiIndexRoute: typeof AppWikiIndexRoute
  AppWorkItemsIndexRoute: typeof AppWorkItemsIndexRoute
  AppAccountingContactsIdRoute: typeof AppAccountingContactsIdRoute
  AppAccountingExpensesIdRoute: typeof AppAccountingExpensesIdRoute
  AppAccountingInvoicesIdRoute: typeof AppAccountingInvoicesIdRoute
  AppAnalysisChatsChatIdRoute: typeof AppAnalysisChatsChatIdRoute
  AppAnalysisDiscordChannelIdRoute: typeof AppAnalysisDiscordChannelIdRoute
  AppAnalysisHistoryIdRoute: typeof AppAnalysisHistoryIdRoute
  AppCustomersIdEditRoute: typeof AppCustomersIdEditRoute
  AppSuggestionsWorkItemsReviewRoute: typeof AppSuggestionsWorkItemsReviewRoute
  AppWorkItemsNewTypeRoute: typeof AppWorkItemsNewTypeRoute
  AppAccountingContactsIndexRoute: typeof AppAccountingContactsIndexRoute
  AppAccountingExpensesIndexRoute: typeof AppAccountingExpensesIndexRoute
  AppAccountingInvoicesIndexRoute: typeof AppAccountingInvoicesIndexRoute
  AppAnalysisDiscordIndexRoute: typeof AppAnalysisDiscordIndexRoute
  AppAnalysisHistoryIndexRoute: typeof AppAnalysisHistoryIndexRoute
  AppCustomersIdIndexRoute: typeof AppCustomersIdIndexRoute
  AppWorkItemsNewIndexRoute: typeof AppWorkItemsNewIndexRoute
  AppGroupProjectWork_itemsIidRoute: typeof AppGroupProjectWork_itemsIidRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppActivityRoute: AppActivityRoute,
  AppAlertsRoute: AppAlertsRoute,
  AppCoderLearningsRoute: AppCoderLearningsRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppDownloadRoute: AppDownloadRoute,
  AppProfileRoute: AppProfileRoute,
  AppReportsRoute: AppReportsRoute,
  AppReviewerLearningsRoute: AppReviewerLearningsRoute,
  AppTimeEntriesAllRoute: AppTimeEntriesAllRoute,
  AppIndexRoute: AppIndexRoute,
  AppGroupProjectRoute: AppGroupProjectRouteWithChildren,
  AppAccountingAssetsRoute: AppAccountingAssetsRoute,
  AppAccountingBankRoute: AppAccountingBankRoute,
  AppAccountingCashRoute: AppAccountingCashRoute,
  AppAccountingCutoverRoute: AppAccountingCutoverRoute,
  AppAccountingDataboxRoute: AppAccountingDataboxRoute,
  AppAccountingDocumentsRoute: AppAccountingDocumentsRoute,
  AppAccountingInboxRoute: AppAccountingInboxRoute,
  AppAccountingJournalRoute: AppAccountingJournalRoute,
  AppAccountingLedgerRoute: AppAccountingLedgerRoute,
  AppAccountingMissingRoute: AppAccountingMissingRoute,
  AppAccountingOpeningRoute: AppAccountingOpeningRoute,
  AppAccountingRecurringRoute: AppAccountingRecurringRoute,
  AppAccountingSettingsRoute: AppAccountingSettingsRoute,
  AppAccountingStatementsRoute: AppAccountingStatementsRoute,
  AppAccountingTaxDocumentsRoute: AppAccountingTaxDocumentsRoute,
  AppAccountingVatRoute: AppAccountingVatRoute,
  AppAdminSeafileFoldersRoute: AppAdminSeafileFoldersRoute,
  AppAdminVaultCollectionsRoute: AppAdminVaultCollectionsRoute,
  AppAgentsSlugRoute: AppAgentsSlugRouteWithChildren,
  AppAnalysisEmailRoute: AppAnalysisEmailRoute,
  AppAnalysisMeetingsRoute: AppAnalysisMeetingsRoute,
  AppAnalysisSourcesRoute: AppAnalysisSourcesRoute,
  AppAnalysisWhatsappRoute: AppAnalysisWhatsappRoute,
  AppBillingIdRoute: AppBillingIdRoute,
  AppBillingAiSpendRoute: AppBillingAiSpendRoute,
  AppBillingNewRoute: AppBillingNewRoute,
  AppConnectHubRoute: AppConnectHubRoute,
  AppCustomersNewRoute: AppCustomersNewRoute,
  AppDownloadScannerRoute: AppDownloadScannerRoute,
  AppIdeasIdRoute: AppIdeasIdRoute,
  AppLogSourcesLearningsRoute: AppLogSourcesLearningsRoute,
  AppProjectsSlugRoute: AppProjectsSlugRouteWithChildren,
  AppProjectsNewRoute: AppProjectsNewRoute,
  AppSuggestionsLearningsRoute: AppSuggestionsLearningsRoute,
  AppSuggestionsTimeEntriesRoute: AppSuggestionsTimeEntriesRoute,
  AppSuggestionsTimeEntriesAllRoute: AppSuggestionsTimeEntriesAllRoute,
  AppSuggestionsWorkItemsRoute: AppSuggestionsWorkItemsRoute,
  AppSyncIdRoute: AppSyncIdRoute,
  AppTimeEntriesNewRoute: AppTimeEntriesNewRoute,
  AppUsersIdRoute: AppUsersIdRoute,
  AppWikiSplatRoute: AppWikiSplatRoute,
  AppWorkItemIdRoute: AppWorkItemIdRoute,
  AppWorkItemsIdRoute: AppWorkItemsIdRoute,
  AppAccountingIndexRoute: AppAccountingIndexRoute,
  AppAgentsIndexRoute: AppAgentsIndexRoute,
  AppAnalysisIndexRoute: AppAnalysisIndexRoute,
  AppBillingIndexRoute: AppBillingIndexRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppIdeasIndexRoute: AppIdeasIndexRoute,
  AppLogSourcesIndexRoute: AppLogSourcesIndexRoute,
  AppMyIndexRoute: AppMyIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppSuggestionsIndexRoute: AppSuggestionsIndexRoute,
  AppSyncIndexRoute: AppSyncIndexRoute,
  AppTimeEntriesIndexRoute: AppTimeEntriesIndexRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
  AppWikiIndexRoute: AppWikiIndexRoute,
  AppWorkItemsIndexRoute: AppWorkItemsIndexRoute,
  AppAccountingContactsIdRoute: AppAccountingContactsIdRoute,
  AppAccountingExpensesIdRoute: AppAccountingExpensesIdRoute,
  AppAccountingInvoicesIdRoute: AppAccountingInvoicesIdRoute,
  AppAnalysisChatsChatIdRoute: AppAnalysisChatsChatIdRoute,
  AppAnalysisDiscordChannelIdRoute: AppAnalysisDiscordChannelIdRoute,
  AppAnalysisHistoryIdRoute: AppAnalysisHistoryIdRoute,
  AppCustomersIdEditRoute: AppCustomersIdEditRoute,
  AppSuggestionsWorkItemsReviewRoute: AppSuggestionsWorkItemsReviewRoute,
  AppWorkItemsNewTypeRoute: AppWorkItemsNewTypeRoute,
  AppAccountingContactsIndexRoute: AppAccountingContactsIndexRoute,
  AppAccountingExpensesIndexRoute: AppAccountingExpensesIndexRoute,
  AppAccountingInvoicesIndexRoute: AppAccountingInvoicesIndexRoute,
  AppAnalysisDiscordIndexRoute: AppAnalysisDiscordIndexRoute,
  AppAnalysisHistoryIndexRoute: AppAnalysisHistoryIndexRoute,
  AppCustomersIdIndexRoute: AppCustomersIdIndexRoute,
  AppWorkItemsNewIndexRoute: AppWorkItemsNewIndexRoute,
  AppGroupProjectWork_itemsIidRoute: AppGroupProjectWork_itemsIidRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  ScanRoute: ScanRoute,
  LoginLinkRoute: LoginLinkRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
